(function () {
  var lastToastAt = 0;
  var klaviyoReviewSummaryCache = {};
  var klaviyoProductRatingsCache = {};
  var klaviyoProductRatingsRequestCache = {};
  var tallOwlRotatingScentIndexCache = {};

  // Klaviyo form WF7GV3 is an orphaned live version whose parent is no longer
  // available in the Klaviyo UI/API. Suppress only that stale BOGO Free popup
  // while the vendor support case is open; keep onsite tracking, reviews,
  // consent records, and every other form intact.
  function initStaleKlaviyoFormContainment() {
    var staleFormId = 'WF7GV3';
    var staleFormSelector = '[data-testid="klaviyo-form-' + staleFormId + '"]';

    function suppressStaleForm() {
      var staleForm = document.querySelector(staleFormSelector);
      if (!staleForm) return false;

      var dialog = staleForm.closest('[role="dialog"]');
      if (dialog) {
        dialog.remove();
      } else {
        staleForm.remove();
      }

      return true;
    }

    window.addEventListener('klaviyoForms', function (event) {
      var detail = event && event.detail ? event.detail : {};
      if (detail.formId !== staleFormId || detail.type !== 'open') return;

      var body = document.body;
      var originalBodyState = body ? {
        hadScrollLockClass: body.classList.contains('klaviyo-prevent-body-scrolling'),
        overflow: body.style.overflow,
        overflowY: body.style.overflowY
      } : null;

      function hasAnotherKlaviyoForm() {
        var forms = document.querySelectorAll('[data-testid^="klaviyo-form-"]');
        for (var index = 0; index < forms.length; index += 1) {
          if (!forms[index].matches(staleFormSelector)) return true;
        }
        return false;
      }

      function restoreBodyScrollIfSafe() {
        if (!body || !originalBodyState) return;
        if (document.querySelector(staleFormSelector) || hasAnotherKlaviyoForm()) return;

        if (
          !originalBodyState.hadScrollLockClass &&
          body.classList.contains('klaviyo-prevent-body-scrolling')
        ) {
          body.classList.remove('klaviyo-prevent-body-scrolling');
        }
        if (body.style.overflow === 'hidden' && originalBodyState.overflow !== 'hidden') {
          body.style.overflow = originalBodyState.overflow;
        }
        if (body.style.overflowY === 'hidden' && originalBodyState.overflowY !== 'hidden') {
          body.style.overflowY = originalBodyState.overflowY;
        }
      }

      // Klaviyo emits its open event before inserting the popup, then applies
      // the body scroll lock after insertion. Watch both phases briefly so
      // removing this one orphaned form can never leave the storefront locked.
      var formObserver = new MutationObserver(function () {
        suppressStaleForm();
        restoreBodyScrollIfSafe();
      });
      formObserver.observe(document.documentElement, {
        childList: true,
        subtree: true
      });

      var bodyObserver = body ? new MutationObserver(function () {
        restoreBodyScrollIfSafe();
      }) : null;
      if (bodyObserver) {
        bodyObserver.observe(body, {
          attributes: true,
          attributeFilter: ['class', 'style']
        });
      }

      suppressStaleForm();
      restoreBodyScrollIfSafe();

      window.setTimeout(function () {
        suppressStaleForm();
        restoreBodyScrollIfSafe();
        formObserver.disconnect();
        if (bodyObserver) bodyObserver.disconnect();
      }, 3000);
    });
  }

  initStaleKlaviyoFormContainment();

  // --- Global serialized cart-write queue ---
  // Shopify's cart AJAX API (/cart/add|update|change.js) races/drops writes when
  // several fire at once. The promo flag-writer, the free-gift picker, and the
  // BOGO auto-add all mutate the cart on the same events, so every cart write
  // goes through this one chain to take turns - otherwise a collision silently
  // drops the free 2nd unit or the gift (the "not added until refresh" bug).
  var tallOwlCartWriteChain = Promise.resolve();
  var tallOwlCartRecoveryRequired = false;
  var TALL_OWL_CART_REQUEST_TIMEOUT_MS = 12000;

  /* The pair offer's percent off the second item: 50 unless the theme setting
     says exactly 100. The layout prints the setting on <html>. The Tall Owl
     Promos Function decides the real discount by the same rule (bogoPercent). */
  function tallOwlPairOfferPercent() {
    var root = typeof document !== 'undefined' ? document.documentElement : null;
    return root && typeof root.getAttribute === 'function' &&
      root.getAttribute('data-tall-owl-pair-offer-percent') === '100' ? 100 : 50;
  }

  function tallOwlPairOfferSaving(cents) {
    return Math.floor(cents * tallOwlPairOfferPercent() / 100);
  }

  function tallOwlRequireCartRecovery(error) {
    var failure = error && typeof error === 'object' && Object.isExtensible(error)
      ? error : new Error('Cart state could not be confirmed');
    failure.writeUncertain = true;
    failure.recoveryRequired = true;
    if (failure !== error) failure.cause = error;
    var firstFailure = !tallOwlCartRecoveryRequired;
    tallOwlCartRecoveryRequired = true;
    if (firstFailure && typeof showToast === 'function') showToast('Your cart may have changed. Reload this page to check it before adding or changing items.', true);
    document.dispatchEvent(new CustomEvent('cart:recovery', { detail: { recoveryRequired: true } }));
    return failure;
  }

  function tallOwlCartRecoveryError() {
    var error = new Error('Reload this page to check your cart before making another change.');
    error.recoveryRequired = true;
    return error;
  }

  // The deadline covers headers AND the body. Aborting a client request does
  // not prove Shopify cancelled its write: uncertain writes close this page's
  // mutation gate, even if the underlying request finishes after the deadline.
  // Reads stay available to show what the cart actually contains. Never replay
  // an add automatically or release a timed-out write into another mutation.
  function tallOwlCartRequest(url, options) {
    var requestOptions = Object.assign({}, options || {});
    var isWrite = String(requestOptions.method || 'GET').toUpperCase() !== 'GET';
    if (isWrite && tallOwlCartRecoveryRequired) return Promise.reject(tallOwlCartRecoveryError());
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var originalSignal = requestOptions.signal;
    var timer;
    var abortListener;
    var finished = false;
    var rejectedStatus = 0;
    if (controller) requestOptions.signal = controller.signal;

    return new Promise(function (resolve, reject) {
      function finish(error, response) {
        var hasFailure = arguments.length === 1;
        if (finished) return;
        finished = true;
        window.clearTimeout(timer);
        if (originalSignal && abortListener) originalSignal.removeEventListener('abort', abortListener);
        if (hasFailure) {
          var originalError = error;
          error = new Error(originalError && typeof originalError.message === 'string'
            ? originalError.message : 'Cart request failed');
          error.cause = originalError;
          if (originalError && typeof originalError === 'object') {
            error.name = originalError.name || error.name;
            ['status', 'cartRejected', 'writeUncertain', 'recoveryRequired'].forEach(function (field) {
              if (originalError[field] !== undefined) error[field] = originalError[field];
            });
          }
          if (rejectedStatus) { error.cartRejected = true; error.status = rejectedStatus; }
          if (isWrite && !error.cartRejected) error = tallOwlRequireCartRecovery(error);
          reject(error);
        } else {
          resolve(response);
        }
      }
      function abortRequest() {
        var error = new Error('Cart request timed out.');
        error.name = 'AbortError';
        finish(error);
        if (controller) controller.abort();
      }
      timer = window.setTimeout(abortRequest, TALL_OWL_CART_REQUEST_TIMEOUT_MS);
      if (originalSignal) {
        abortListener = abortRequest;
        originalSignal.addEventListener('abort', abortListener, { once: true });
        if (originalSignal.aborted) { abortRequest(); return; }
      }
      Promise.resolve().then(function () {
        // An earlier task may have closed the gate while this call was queued.
        if (isWrite && tallOwlCartRecoveryRequired) throw tallOwlCartRecoveryError();
        return fetch(url, requestOptions);
      }).then(function (response) {
        if (!response.ok && Number(response.status) >= 400 && Number(response.status) < 500) rejectedStatus = Number(response.status);
        return response.text().then(function (body) {
          var parsed;
          var isJsonEndpoint = /\/cart(?:\.js|\/(?:add|change|update)\.js)(?:[?#]|$)/.test(String(url));
          if (response.ok && isJsonEndpoint) {
            parsed = JSON.parse(body);
            var isCartResponse = /\/cart(?:\.js|\/(?:change|update)\.js)(?:[?#]|$)/.test(String(url));
            if (!parsed || typeof parsed !== 'object' ||
                (isCartResponse ? !Array.isArray(parsed.items) :
                  !Array.isArray(parsed.items) && !Number(parsed.id || parsed.variant_id))) {
              throw new Error('Cart response could not be verified');
            }
          } else if (isWrite && Number(response.status) >= 500) {
            var serverError = new Error('Cart request could not be confirmed');
            serverError.status = response.status;
            throw serverError;
          }
          return {
            ok: response.ok, status: response.status, headers: response.headers,
            json: function () { return Promise.resolve().then(function () { return parsed || JSON.parse(body); }); },
            text: function () { return Promise.resolve(body); }
          };
        });
      }).then(function (response) { finish(null, response); }, function (error) { finish(error); });
    });
  }

  // Counts of cart writes queued and finished. A caller that reads the cart
  // ahead of its own write compares them to prove that no other write was
  // waiting, running or queued in between.
  var tallOwlCartWritesQueued = 0;
  var tallOwlCartWritesSettled = 0;
  function tallOwlQueueCartWrite(task) {
    function run() {
      if (tallOwlCartRecoveryRequired) throw tallOwlCartRecoveryError();
      return task();
    }
    function settled() { tallOwlCartWritesSettled += 1; }
    tallOwlCartWritesQueued += 1;
    var result = tallOwlCartWriteChain.then(run, run);
    tallOwlCartWriteChain = result.then(settled, settled);
    return result;
  }
  window.tallOwlCartWriteActivity = function () {
    return { queued: tallOwlCartWritesQueued, settled: tallOwlCartWritesSettled };
  };
  window.tallOwlCartRequest = tallOwlCartRequest;
  // The gift check reads the cart as the page loads, and the analytics script
  // wants the same cart at the same moment. The gift check's own request is
  // offered here only while it is in flight; a script that asks during that
  // time gets a private copy of its result. Nothing is kept once it settles,
  // so any later caller makes its own fresh read.
  var tallOwlLoadCartRead = null;
  function tallOwlOfferLoadCart(read) {
    tallOwlLoadCartRead = read;
    function release() { if (tallOwlLoadCartRead === read) tallOwlLoadCartRead = null; }
    read.then(release, release);
  }
  window.tallOwlLoadCart = function () {
    return tallOwlLoadCartRead
      ? tallOwlLoadCartRead.then(function (cart) { return JSON.parse(JSON.stringify(cart)); })
      : null;
  };
  window.tallOwlRequireCartRecovery = tallOwlRequireCartRecovery;
  window.tallOwlCartWritesBlocked = function () { return tallOwlCartRecoveryRequired; };
  function tallOwlRestoreCartVariants(beforeCart, maxDeltas) {
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    function identity(line) {
      return JSON.stringify([String(line.variant_id || line.id),
        Object.keys(line.properties || {}).sort().map(function (key) { return [key, line.properties[key]]; }),
        String(line.selling_plan_allocation && line.selling_plan_allocation.selling_plan && line.selling_plan_allocation.selling_plan.id || '')]);
    }
    function counts(cart) {
      if (!cart || !Array.isArray(cart.items)) throw new Error('Unable to verify cart recovery');
      return cart.items.reduce(function (result, line) {
        if (!line.key || !Number.isInteger(Number(line.quantity)) || Number(line.quantity) <= 0) throw new Error('Unable to verify cart item');
        var key = identity(line); result[key] = (result[key] || 0) + Number(line.quantity); return result;
      }, {});
    }
    function read() {
      return tallOwlCartRequest(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (response) { if (!response.ok) throw new Error('Unable to read cart recovery'); return response.json(); });
    }
    var expected = counts(beforeCart);
    function restore(cart) {
      if (tallOwlCartRecoveryRequired) throw tallOwlCartRecoveryError();
      var current = counts(cart);
      var keys = Object.keys(expected).concat(Object.keys(current));
      var excessByVariant = {};
      keys.forEach(function (key) {
        var variant = JSON.parse(key)[0];
        var delta = (current[key] || 0) - (expected[key] || 0);
        if (delta < 0 || delta && !Object.prototype.hasOwnProperty.call(maxDeltas, variant)) throw new Error('Cart changed during recovery');
      });
      cart.items.forEach(function (line) {
        var variant = String(line.variant_id || line.id);
        var key = identity(line);
        if (!Object.prototype.hasOwnProperty.call(maxDeltas, variant)) return;
        // Count each identity once, even when discounts split it into lines.
        if (cart.items.filter(function (item) { return identity(item) === key; })[0] !== line) return;
        excessByVariant[variant] = (excessByVariant[variant] || 0) + (current[key] || 0) - (expected[key] || 0);
      });
      Object.keys(excessByVariant).forEach(function (variant) {
        if (excessByVariant[variant] > Number(maxDeltas[variant])) throw new Error('Cart changed during recovery');
      });
      var line = cart.items.filter(function (item) { return (current[identity(item)] || 0) > (expected[identity(item)] || 0); })[0];
      if (!line) return Promise.resolve(cart);
      var key = identity(line);
      var quantity = Math.max(0, Number(line.quantity) - ((current[key] || 0) - (expected[key] || 0)));
      return tallOwlCartRequest(root + 'cart/change.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: line.key, quantity: quantity })
      }).then(function (response) { if (!response.ok) throw new Error('Cart recovery was rejected'); return response.json(); })
        .then(function (updated) {
          if ((counts(updated)[key] || 0) >= current[key]) throw new Error('Cart recovery did not change the quantity');
          return restore(updated);
        });
    }
    return read().then(restore).then(read).then(function (cart) {
      var actual = counts(cart);
      if (!Object.keys(expected).concat(Object.keys(actual)).every(function (key) { return (expected[key] || 0) === (actual[key] || 0); })) throw new Error('Cart recovery could not be confirmed');
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      document.dispatchEvent(new CustomEvent('cart:build'));
      return cart;
    }).catch(function (error) { throw tallOwlRequireCartRecovery(error); });
  }

  function tallOwlReadFailedAdd(error) {
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    return tallOwlCartRequest(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (response) { if (!response.ok) throw new Error('Cart read failed'); return response.json(); })
      .then(function (cart) {
        error.cartReadVerified = true;
        error.cart = cart;
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
        document.dispatchEvent(new CustomEvent('cart:build'));
        throw error;
      }).catch(function (readError) { if (readError !== error) throw tallOwlRequireCartRecovery(readError); throw error; });
  }

  // Only call inside a paid add's shared cart-write transaction. The helper
  // is absent when the gift is disabled; paid add semantics stay unchanged.
  function tallOwlCartSectionRequest(body, beforeCart) {
    if (typeof window.tallOwlShouldBundlePaidCart === 'function' && !window.tallOwlShouldBundlePaidCart(beforeCart)) return body;
    return window.theme && window.theme.cart && typeof window.theme.cart.addCartSectionRequest === 'function'
      ? window.theme.cart.addCartSectionRequest(body) : body;
  }

  // State is requested separately from optional drawer markup. Only baseline-
  // backed pair transactions call this; other add paths retain their contract.
  function tallOwlCartStateRequest(body, beforeCart) {
    var api = window.theme && window.theme.cart;
    if (api && typeof api.addCartStateRequest === 'function') {
      return api.addCartStateRequest(body, { renderCart:
        typeof window.tallOwlShouldBundlePaidCart !== 'function' || window.tallOwlShouldBundlePaidCart(beforeCart) });
    }
    return tallOwlCartSectionRequest(body, beforeCart);
  }

  function tallOwlIsCartStateProjection(cart) {
    var api = window.theme && window.theme.cart;
    return !!(api && typeof api.isCartStateProjection === 'function' && api.isCartStateProjection(cart));
  }

  // Shadow mode keeps the native GET authoritative. Optional section/parser or
  // comparison failures cannot change a paid result or trigger another write.
  function tallOwlReadPaidCartState(payload, readCart) {
    var api = window.theme && window.theme.cart;
    var projected = null;
    var mode = 'shadow';
    try {
      if (api && typeof api.getCartStateMode === 'function') mode = api.getCartStateMode();
      if (api && typeof api.getCartStateProjection === 'function') projected = api.getCartStateProjection(payload);
    } catch (error) { projected = null; }
    if (mode === 'enabled' && projected && tallOwlIsCartStateProjection(projected)) return Promise.resolve(projected);
    return readCart().then(function (cart) {
      if (mode === 'shadow' && api && typeof api.compareCartStateProjection === 'function') {
        try { api.compareCartStateProjection(projected, cart); } catch (error) { /* Diagnostics never own commerce. */ }
      }
      return cart;
    });
  }

  function tallOwlReadFullPaidCart(paidSections) {
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    return tallOwlCartRequest(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to confirm the complete cart');
        return response.json();
      }).then(function (cart) {
        if (!cart || !Array.isArray(cart.items) || tallOwlIsCartStateProjection(cart)) throw new Error('Complete cart unavailable');
        cart.sections = paidSections;
        return cart;
      }).catch(function (error) { throw tallOwlRequireCartRecovery(error); });
  }

  function tallOwlFinishPaidAdd(confirmedCart, paidSections) {
    var requireFullCart = tallOwlIsCartStateProjection(confirmedCart);
    if (confirmedCart && Array.isArray(confirmedCart.items)) confirmedCart.sections = paidSections;
    var finished = typeof window.tallOwlReconcileGiftAfterAdd === 'function'
      ? window.tallOwlReconcileGiftAfterAdd(confirmedCart, paidSections, requireFullCart)
      : Promise.resolve(confirmedCart);
    return finished.then(function (cart) {
      // Projection fields are sufficient for internal checks, not public cart
      // events. A no-op/disabled gift path still needs the native full snapshot.
      return requireFullCart && (!cart || tallOwlIsCartStateProjection(cart)) ? tallOwlReadFullPaidCart(paidSections) : cart;
    });
  }
  window.tallOwlCartStateRequest = tallOwlCartStateRequest;
  window.tallOwlReadPaidCartState = tallOwlReadPaidCartState;
  window.tallOwlFinishPaidAdd = tallOwlFinishPaidAdd;
  // Shared storefront features use this queue instead of creating competing
  // cart-write chains. Commerce results still come from Shopify cart JSON.
  window.tallOwlQueueCartWrite = tallOwlQueueCartWrite;
  // Set true when the shopper clicks "View cart" so the deferred gift scent
  // popup does not flash open as we navigate away to the cart.

  function readStorageValue(storage, key) {
    if (!storage) return '';
    try {
      return storage.getItem(key) || '';
    } catch (error) {
      return '';
    }
  }

  function writeStorageValue(storage, key, value) {
    if (!storage) return;
    try {
      storage.setItem(key, value);
    } catch (error) {
      /* Ignore storage write issues */
    }
  }

  function getReviewSummaryCompanyId(companyId) {
    var trimmed = String(companyId || '').trim();
    return trimmed || 'UJMPJV';
  }

  function buildReviewSummaryUrl(companyId, subtype) {
    var params = new URLSearchParams();
    params.set('product_id', 'all');
    params.set('company_id', companyId);
    params.set('limit', '1');
    params.set('offset', '0');
    params.set('sort', '0');
    params.set('filter', '');
    params.set('type', 'reviews');
    params.set('media', 'false');
    if (subtype) params.set('subtype', subtype);
    return 'https://fast.a.klaviyo.com/reviews/api/client_reviews/all/?' + params.toString();
  }

  async function fetchSummaryPart(companyId, subtype) {
    var response = await fetch(buildReviewSummaryUrl(companyId, subtype), { method: 'GET' });
    if (!response.ok) throw new Error('Failed to fetch Klaviyo review summary');
    var payload = await response.json();
    var summary = payload && payload.summary ? payload.summary : null;
    if (!summary) return null;

    var count = Number(summary.review_count);
    var rating = Number(summary.star_rating);
    if (!Number.isFinite(count) || count <= 0 || !Number.isFinite(rating)) return null;

    return {
      count: Math.round(count),
      rating: rating
    };
  }

  function combineSummaryParts(parts) {
    var valid = (parts || []).filter(function (part) {
      return part && part.count > 0;
    });
    if (!valid.length) return null;

    var totalCount = 0;
    var weightedRatingTotal = 0;
    valid.forEach(function (part) {
      totalCount += part.count;
      weightedRatingTotal += part.rating * part.count;
    });
    if (!totalCount) return null;

    return {
      count: totalCount,
      rating: weightedRatingTotal / totalCount
    };
  }

  function getSharedKlaviyoReviewSummary(companyId) {
    var safeCompanyId = getReviewSummaryCompanyId(companyId);
    if (klaviyoReviewSummaryCache[safeCompanyId]) {
      return klaviyoReviewSummaryCache[safeCompanyId];
    }

    klaviyoReviewSummaryCache[safeCompanyId] = Promise.all([
      fetchSummaryPart(safeCompanyId, ''),
      fetchSummaryPart(safeCompanyId, 'store')
    ])
      .then(function (parts) {
        return combineSummaryParts(parts);
      })
      .catch(function (error) {
        delete klaviyoReviewSummaryCache[safeCompanyId];
        throw error;
      });

    return klaviyoReviewSummaryCache[safeCompanyId];
  }

  function getCompanyRatingsCache(companyId) {
    var safeCompanyId = getReviewSummaryCompanyId(companyId);
    if (!klaviyoProductRatingsCache[safeCompanyId]) {
      klaviyoProductRatingsCache[safeCompanyId] = {};
    }
    return klaviyoProductRatingsCache[safeCompanyId];
  }

  function getRequestCacheKey(companyId, productIds) {
    return getReviewSummaryCompanyId(companyId) + '::' + productIds.slice().sort().join(',');
  }

  function fetchKlaviyoProductRatings(companyId, productIds) {
    var safeCompanyId = getReviewSummaryCompanyId(companyId);
    var uniqueIds = Array.from(
      new Set(
        (productIds || [])
          .map(function (id) {
            return String(id || '').trim();
          })
          .filter(function (id) {
            return id.length > 0;
          })
      )
    );
    if (!uniqueIds.length) return Promise.resolve({});

    var companyCache = getCompanyRatingsCache(safeCompanyId);
    var missingIds = uniqueIds.filter(function (id) {
      return !Object.prototype.hasOwnProperty.call(companyCache, id);
    });

    function buildResult() {
      var result = {};
      uniqueIds.forEach(function (id) {
        if (Object.prototype.hasOwnProperty.call(companyCache, id)) {
          result[id] = companyCache[id];
        }
      });
      return result;
    }

    if (!missingIds.length) {
      return Promise.resolve(buildResult());
    }

    var requestKey = getRequestCacheKey(safeCompanyId, missingIds);
    if (!klaviyoProductRatingsRequestCache[requestKey]) {
      var params = new URLSearchParams();
      params.set('company_id', safeCompanyId);
      params.set('products', JSON.stringify(missingIds));

      klaviyoProductRatingsRequestCache[requestKey] = fetch(
        'https://fast.a.klaviyo.com/reviews/api/client_reviews/?' + params.toString(),
        { method: 'GET' }
      )
        .then(function (response) {
          if (!response.ok) throw new Error('Unable to load Klaviyo product ratings');
          return response.json();
        })
        .then(function (payload) {
          var products = payload && Array.isArray(payload.products) ? payload.products : [];
          var found = {};

          products.forEach(function (product) {
            if (!product || product.shopify_id == null) return;
            var id = String(product.shopify_id);
            var rating = Number(product.star_rating);
            var count = Number(product.review_count);
            if (!Number.isFinite(rating)) return;

            found[id] = true;
            companyCache[id] = {
              rating: Math.round(rating * 10) / 10,
              count: Number.isFinite(count) && count > 0 ? Math.round(count) : 0
            };
          });

          missingIds.forEach(function (id) {
            if (!found[id]) {
              companyCache[id] = null;
            }
          });
        })
        .finally(function () {
          delete klaviyoProductRatingsRequestCache[requestKey];
        });
    }

    return klaviyoProductRatingsRequestCache[requestKey].then(function () {
      return buildResult();
    });
  }

  window.tallOwlReviews = window.tallOwlReviews || {};
  window.tallOwlReviews.getSummary = getSharedKlaviyoReviewSummary;
  window.tallOwlReviews.getProductRatings = fetchKlaviyoProductRatings;
  window.dispatchEvent(new CustomEvent('tallowl:reviews-helper-ready'));

  function collectGridRatingElements(scope) {
    var elements = [];
    if (!scope) return elements;

    if (scope.nodeType === 1 && scope.matches('[data-klaviyo-grid-rating][data-klaviyo-product-id]')) {
      elements.push(scope);
    }

    if (scope.querySelectorAll) {
      elements = elements.concat(
        Array.prototype.slice.call(scope.querySelectorAll('[data-klaviyo-grid-rating][data-klaviyo-product-id]'))
      );
    }

    return elements;
  }

  function applyGridRating(el, ratingData) {
    var valueEl = el.querySelector('.tall-owl-grid-rating__value');
    var countEl = el.querySelector('.tall-owl-grid-rating__count');
    if (!valueEl || !countEl || !ratingData) return;

    var rating = Number(ratingData.rating);
    var safeCount = Number(ratingData.count);

    // No real reviews yet (new products): keep the stars row hidden entirely.
    if (!Number.isFinite(rating) || rating <= 0 || !Number.isFinite(safeCount) || safeCount <= 0) {
      el.hidden = true;
      return;
    }

    var normalizedRating = (Math.round(rating * 10) / 10).toFixed(1);
    var formattedCount = Math.round(safeCount).toLocaleString();

    valueEl.textContent = normalizedRating;
    var reviewLabel = Math.round(safeCount) === 1 ? 'review' : 'reviews';
    countEl.textContent = formattedCount + ' ' + reviewLabel;
    el.setAttribute(
      'aria-label',
      'Rated ' + normalizedRating + ' out of 5 from ' + formattedCount + ' ' + reviewLabel
    );
    el.hidden = false;
  }

  function initCollectionGridRatings(scope) {
    if (!document.body.classList.contains('template-collection')) return;

    var root = scope || document;
    var ratingEls = collectGridRatingElements(root).filter(function (el) {
      return el.getAttribute('data-klaviyo-grid-rating-ready') !== 'true';
    });
    if (!ratingEls.length) return;

    var companyId = 'UJMPJV';
    for (var i = 0; i < ratingEls.length; i += 1) {
      var configuredCompanyId = (ratingEls[i].getAttribute('data-klaviyo-company-id') || '').trim();
      if (configuredCompanyId) {
        companyId = configuredCompanyId;
        break;
      }
    }

    var productIds = ratingEls
      .map(function (el) {
        return (el.getAttribute('data-klaviyo-product-id') || '').trim();
      })
      .filter(function (id) {
        return id.length > 0;
      });
    if (!productIds.length) return;

    fetchKlaviyoProductRatings(companyId, productIds)
      .then(function (ratingsById) {
        ratingEls.forEach(function (el) {
          var productId = (el.getAttribute('data-klaviyo-product-id') || '').trim();
          if (productId && ratingsById && ratingsById[productId]) {
            applyGridRating(el, ratingsById[productId]);
          }
          el.setAttribute('data-klaviyo-grid-rating-ready', 'true');
        });
      })
      .catch(function () {
        ratingEls.forEach(function (el) {
          el.setAttribute('data-klaviyo-grid-rating-ready', 'true');
        });
      });
  }

  function initCollectionGridRatingsObserver() {
    if (!document.body.classList.contains('template-collection') || !window.MutationObserver) return;
    var container = document.getElementById('CollectionAjaxContent') || document.getElementById('MainContent');
    if (!container) return;

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes, function (node) {
          if (!node || node.nodeType !== 1) return;
          initCollectionGridRatings(node);
          initRotatingScentCards(node);
          initCollectionCardForms(node);
        });
      });
    });
    observer.observe(container, { childList: true, subtree: true });
  }

  function initCollectionCardForms(scope) {
    if (!document.body.classList.contains('template-collection') && !document.body.classList.contains('template-index') && !document.querySelector('.tall-owl-shopping-recovery [data-tall-owl-collection-card-form]')) return;

    var root = scope || document;
    var forms = [];
    if (root.nodeType === 1 && root.matches('[data-tall-owl-collection-card-form]')) {
      forms.push(root);
    }
    if (root.querySelectorAll) {
      forms = forms.concat(Array.prototype.slice.call(root.querySelectorAll('[data-tall-owl-collection-card-form]')));
    }

    forms.forEach(function (form) {
      if (form.getAttribute('data-tall-owl-collection-card-bound') === 'true') return;
      form.setAttribute('data-tall-owl-collection-card-bound', 'true');

      // Shopify's shop_events_listener looks up every /cart/add form's variant
      // in the page's product list on load. Search lists only its results, so
      // empty-search recovery cards logged trackViewedProductVariant errors.
      // These cards submit through addToCart below; the native action stays
      // in the markup for no-JS shoppers only.
      var nativeAction = form.getAttribute('action');
      if (nativeAction && typeof form.closest === 'function' && form.closest('.tall-owl-shopping-recovery')) {
        form.setAttribute('data-tall-owl-native-action', nativeAction);
        form.removeAttribute('action');
      }

      var select = form.querySelector('select[name="id"]');
      var button = form.querySelector('.tall-owl-collection-card-form__button');
      var error = form.querySelector('[data-collection-card-error]');
      var card = form.closest('.grid-product');
      var priceEl = card ? card.querySelector('[data-tall-owl-card-price]') : null;

      function syncSelectedVariant() {
        if (!select) return;
        var option = select.options[select.selectedIndex];
        if (!option) return;

        if (priceEl && option.getAttribute('data-price')) {
          priceEl.textContent = option.getAttribute('data-price');
        }

        // Keep every card's photograph and destination tied to its selected SKU.
        if (card) {
          var photoSurface = card.querySelector('.grid-product__image-mask');
          var selectedPhotoGround = option.getAttribute('data-photo-ground');
          if (photoSurface && selectedPhotoGround) {
            photoSurface.style.setProperty('--to-photo-ground', selectedPhotoGround);
          }
          var image = card.querySelector('.grid-product__image-mask img');
          var trioCard = card.querySelector('[data-trio-true-scale-card]');
          var link = card.querySelector('.grid-product__link');
          var pending = card.querySelector('[data-tall-owl-variant-photo-pending]');
          var selectedImageUrl = option.getAttribute('data-variant-image');
          var variantTitle = option.getAttribute('data-variant-title') || option.textContent.trim();
          if (trioCard && trioCard.getAttribute('data-trio-variant-id') !== option.value) {
            var trioTemplate = card.querySelector('template[data-trio-card-template][data-trio-variant-id="' + option.value + '"]');
            if (trioTemplate) {
              trioCard.replaceChildren(trioTemplate.content.cloneNode(true));
              trioCard.setAttribute('data-trio-variant-id', option.value);
            }
          } else if (!trioCard && image && selectedImageUrl) {
            // The first Shop All card starts with the exact selected jar in a
            // smaller theme asset. Keep it until the shopper changes variants.
            if (image.getAttribute('data-tall-owl-optimized-variant-id') !== option.value) {
              image.removeAttribute('data-tall-owl-optimized-variant-id');
              var selectedImageSrcset = buildResponsiveSrcset(selectedImageUrl, [360, 540, 720, 900, 1080]) || selectedImageUrl;
              image.setAttribute('srcset', selectedImageSrcset);
              image.setAttribute('data-srcset', selectedImageSrcset);
              image.setAttribute('data-src', selectedImageUrl);
              image.src = selectedImageUrl;
              image.alt = form.getAttribute('data-product-title') + ' — ' + variantTitle;
              image.style.visibility = '';
              image.removeAttribute('aria-hidden');
            }
          } else if (!trioCard && image && !selectedImageUrl) {
            image.style.visibility = 'hidden';
            image.setAttribute('aria-hidden', 'true');
          }
          if (pending) {
            pending.hidden = !!selectedImageUrl;
            pending.textContent = selectedImageUrl ? '' : form.getAttribute('data-product-title') + ' — ' + variantTitle;
          }
          if (link && option.getAttribute('data-variant-url')) link.href = option.getAttribute('data-variant-url');
        }

        if (button && !button.hasAttribute('data-adding')) {
          var available = option.getAttribute('data-available') !== 'false' && !option.disabled;
          button.disabled = !available;
          button.textContent = available ? 'Add' : 'Sold out';
        }
      }

      if (select) {
        select.addEventListener('change', syncSelectedVariant);
        syncSelectedVariant();
      }

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (!button || button.disabled || button.hasAttribute('data-adding')) return;

        var formData = new FormData(form);
        var variantId = formData.get('id');
        if (!variantId) return;

        var previousText = button.textContent || 'Add';
        if (error) { error.hidden = true; error.textContent = ''; }
        button.disabled = true;
        button.setAttribute('data-adding', 'true');
        button.setAttribute('aria-busy', 'true');
        button.textContent = 'Adding...';

        addToCart(variantId, 1)
          .then(function () {
            button.textContent = 'Added';
            return new Promise(function (resolve) {
              window.setTimeout(resolve, 450);
            });
          })
          .then(function () {
            button.removeAttribute('data-adding');
            button.removeAttribute('aria-busy');
            syncSelectedVariant();
            if (!select) {
              button.disabled = false;
              button.textContent = previousText;
            }
          })
          .catch(function () {
            button.removeAttribute('data-adding');
            button.removeAttribute('aria-busy');
            syncSelectedVariant();
            if (!select) button.disabled = false;
            if (!button.disabled) button.textContent = 'Try again';
            if (error) {
              error.textContent = 'We could not confirm this item was added. Check your cart, then try again.';
              error.hidden = false;
            }
          });
      });
    });
  }

  function collectVariantDescriptionBlocks(scope) {
    var blocks = [];
    if (!scope) return blocks;

    if (scope.nodeType === 1 && scope.matches('[data-variant-description-block]')) {
      blocks.push(scope);
    }

    if (scope.querySelectorAll) {
      blocks = blocks.concat(
        Array.prototype.slice.call(scope.querySelectorAll('[data-variant-description-block]'))
      );
    }

    return blocks;
  }

  function getCurrentVariantIdForSection(productSection) {
    if (!productSection || !productSection.querySelector) return '';
    var currentVariantNode = productSection.querySelector('[data-current-variant-json]');
    if (!currentVariantNode) return '';

    var currentVariant = parseJsonData((currentVariantNode.textContent || '').trim());
    if (!currentVariant || currentVariant.id == null) return '';
    return String(currentVariant.id);
  }

  function renderVariantDescriptionForVariant(block, variantId) {
    if (!block || !block.querySelector) return;

    var output = block.querySelector('[data-variant-description-output]');
    if (!output) return;

    var map = block._tallOwlVariantDescriptionMap || {};
    var optionOneMap = block._tallOwlVariantDescriptionOptionOneMap || {};
    var variantOptionOneMap = block._tallOwlVariantDescriptionVariantOptionOneMap || {};
    var productFallbackHtml = block._tallOwlVariantDescriptionProductFallbackHtml || '';
    var fallbackHtml = block._tallOwlVariantDescriptionFallbackHtml || '';
    var variantKey = variantId == null ? '' : String(variantId);
    var nextHtml = '';
    var optionOneKey = '';

    if (variantKey && Object.prototype.hasOwnProperty.call(map, variantKey)) {
      nextHtml = map[variantKey] || '';
    }

    if (!nextHtml && variantKey && Object.prototype.hasOwnProperty.call(variantOptionOneMap, variantKey)) {
      optionOneKey = variantOptionOneMap[variantKey] || '';
      if (optionOneKey && Object.prototype.hasOwnProperty.call(optionOneMap, optionOneKey)) {
        nextHtml = optionOneMap[optionOneKey] || '';
      }
    }

    if (!nextHtml) {
      nextHtml = productFallbackHtml;
    }

    if (!nextHtml) {
      nextHtml = fallbackHtml;
    }

    if (!isProductDescriptionSafe(nextHtml)) {
      nextHtml = fallbackHtml;
    }

    var resolvedHtml = nextHtml || '';
    if (output.innerHTML !== resolvedHtml) {
      /* Scroll anchoring, not height reservation: reserving the tallest
         description left a permanent ghost gap under every shorter one
         (the default scent's is the shortest, so everyone saw it). The
         block sits ABOVE the pickers, so instead we absorb the height
         change into scroll position - the controls the shopper is
         touching stay exactly where they are, and the description grows
         or shrinks away from them. Only while the block is above the
         viewport top edge of the pickers; never on first render. */
      var anchor = block.parentElement || block;
      var beforeTop = anchor.getBoundingClientRect().bottom;
      output.style.opacity = '0';
      output.innerHTML = resolvedHtml;
      var delta = anchor.getBoundingClientRect().bottom - beforeTop;
      if (delta && block._tallOwlVariantDescriptionRendered && !block.closest('.tall-owl-pdp-detail-copy')) {
        window.scrollBy(0, delta);
      }
      block._tallOwlVariantDescriptionRendered = true;
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          output.style.opacity = '';
        });
      });
    }

    var isEmpty = !(nextHtml && String(nextHtml).replace(/\s+/g, '').length);
    if (isEmpty) {
      block.setAttribute('data-variant-description-empty', 'true');
    } else {
      block.removeAttribute('data-variant-description-empty');
    }
  }

  /*
    Scent descriptions differ in length, and the block sits ABOVE the option
    pickers - without a reserved height every scent tap reflows the controls
    under the shopper's finger. Measure every possible description for this
    product at the live width and hold the block at the tallest one.
  */
  function reserveVariantDescriptionHeight(block) {
    var output = block.querySelector('[data-variant-description-output]');
    if (!output) return;

    var candidates = [];
    function push(html) {
      if (html && String(html).replace(/\s+/g, '').length && candidates.indexOf(html) === -1) {
        candidates.push(html);
      }
    }
    var map = block._tallOwlVariantDescriptionMap || {};
    var optionOneMap = block._tallOwlVariantDescriptionOptionOneMap || {};
    Object.keys(map).forEach(function (k) { push(map[k]); });
    Object.keys(optionOneMap).forEach(function (k) { push(optionOneMap[k]); });
    push(block._tallOwlVariantDescriptionProductFallbackHtml);
    push(block._tallOwlVariantDescriptionFallbackHtml);
    if (candidates.length < 2) return;

    function measure() {
      var width = output.clientWidth;
      if (!width) return;
      var probe = output.cloneNode(false);
      probe.style.cssText =
        'position:absolute;visibility:hidden;pointer-events:none;height:auto;min-height:0;' +
        'width:' + width + 'px;';
      block.appendChild(probe);
      var max = 0;
      candidates.forEach(function (html) {
        probe.innerHTML = html;
        if (probe.offsetHeight > max) max = probe.offsetHeight;
      });
      block.removeChild(probe);
      if (max > 0) output.style.minHeight = max + 'px';
    }

    measure();
    var resizeTimer = null;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(measure, 200);
    });
  }

  function isProductDescriptionSafe(html) {
    var blockedTerms = [
      'acne',
      'cure',
      'cured',
      'dermatitis',
      'eczema',
      'heal',
      'healed',
      'healing',
      'inflammation',
      'inflammatory',
      'inflamed',
      'irritation',
      'psoriasis',
      'rash',
      'restores',
      'rosacea',
      'sensitive skin',
      'steroid',
      'treat',
      'treated',
      'treatment',
      'wound'
    ];
    var container = document.createElement('div');
    container.innerHTML = String(html || '');
    var text = (container.textContent || container.innerText || '').toLowerCase();
    if (!text) return true;

    return !blockedTerms.some(function (term) {
      return text.indexOf(term) !== -1;
    });
  }

  function initVariantDescriptionBlocks(scope) {
    var blocks = collectVariantDescriptionBlocks(scope);
    if (!blocks.length) return;

    blocks.forEach(function (block) {
      if (block.getAttribute('data-variant-description-ready') === 'true') return;

      var mapNode = block.querySelector('[data-variant-description-map]');
      var optionOneMapNode = block.querySelector('[data-variant-description-option-one-map]');
      var variantOptionOneMapNode = block.querySelector('[data-variant-description-variant-option-one-map]');
      var fallbackNode = block.querySelector('template[data-variant-description-fallback]');
      var productFallbackNode = block.querySelector('template[data-variant-description-product-fallback]');
      var productSection = block.closest('.product-section');
      if (!mapNode || !productSection) return;

      var mapData = parseJsonData((mapNode.textContent || '').trim());
      var optionOneMapData = optionOneMapNode ? parseJsonData((optionOneMapNode.textContent || '').trim()) : null;
      var variantOptionOneMapData = variantOptionOneMapNode ? parseJsonData((variantOptionOneMapNode.textContent || '').trim()) : null;
      block._tallOwlVariantDescriptionMap = mapData && typeof mapData === 'object' ? mapData : {};
      block._tallOwlVariantDescriptionOptionOneMap = optionOneMapData && typeof optionOneMapData === 'object' ? optionOneMapData : {};
      block._tallOwlVariantDescriptionVariantOptionOneMap = variantOptionOneMapData && typeof variantOptionOneMapData === 'object' ? variantOptionOneMapData : {};
      block._tallOwlVariantDescriptionProductFallbackHtml = productFallbackNode ? productFallbackNode.innerHTML : '';
      block._tallOwlVariantDescriptionFallbackHtml = fallbackNode ? fallbackNode.innerHTML : '';

      var initialVariantId = (block.getAttribute('data-current-variant-id') || '').trim();
      if (!initialVariantId) {
        initialVariantId = getCurrentVariantIdForSection(productSection);
      }

      renderVariantDescriptionForVariant(block, initialVariantId);

      var onVariantChange = function (event) {
        if (!block.isConnected) {
          productSection.removeEventListener('variantChange', onVariantChange);
          return;
        }

        var variant = event && event.detail && event.detail.variant ? event.detail.variant : null;
        var variantId = variant && variant.id != null ? String(variant.id) : '';
        renderVariantDescriptionForVariant(block, variantId);
      };

      productSection.addEventListener('variantChange', onVariantChange);

      block.setAttribute('data-variant-description-ready', 'true');
    });
  }

  function initVariantDescriptionObserver() {
    if (!window.MutationObserver) return;
    var container = document.getElementById('MainContent') || document.body;
    if (!container) return;

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes, function (node) {
          if (!node || node.nodeType !== 1) return;
          initVariantDescriptionBlocks(node);
        });
      });
    });

    observer.observe(container, { childList: true, subtree: true });
  }

  function parseJsonData(raw) {
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch (error) {
      return null;
    }
  }

  function getSecureRandomInt(maxExclusive) {
    if (!Number.isFinite(maxExclusive) || maxExclusive <= 0) return 0;
    var max = Math.floor(maxExclusive);
    if (max <= 1) return 0;

    if (window.crypto && typeof window.crypto.getRandomValues === 'function') {
      var randomBuffer = new Uint32Array(1);
      window.crypto.getRandomValues(randomBuffer);
      return randomBuffer[0] % max;
    }

    return Math.floor(Math.random() * max);
  }

  function getRotatingScentIndex(productId, variantCount) {
    if (variantCount < 2) return 0;
    var cacheKey = productId || 'unknown';
    if (Object.prototype.hasOwnProperty.call(tallOwlRotatingScentIndexCache, cacheKey)) {
      return tallOwlRotatingScentIndexCache[cacheKey];
    }
    var randomIndex = getSecureRandomInt(variantCount);
    tallOwlRotatingScentIndexCache[cacheKey] = randomIndex;
    return randomIndex;
  }

  function buildResponsiveSrcset(imageUrl, widths) {
    if (!/[?&]width=\d+/.test(imageUrl)) return '';
    return (widths || [200, 280, 420, 560])
      .map(function (w) {
        return imageUrl.replace(/([?&])width=\d+/, '$1width=' + w) + ' ' + w + 'w';
      })
      .join(', ');
  }

  function updateCardImageForVariant(card, imageUrl) {
    if (!imageUrl) return;

    var primaryImage = card.querySelector(
      '.grid__item-image-wrapper .grid__image-ratio img, .grid__item-image-wrapper .image-wrap img, .tall-owl-product-card__image-link img, .tall-owl-product-card__image'
    );
    if (!primaryImage) return;

    // Keep the swap responsive: a single fixed-width srcset forces oversized
    // downloads on mobile (flagged by Lighthouse), so rebuild the width ladder.
    var responsiveSrcset = buildResponsiveSrcset(imageUrl) || imageUrl;
    primaryImage.setAttribute('src', imageUrl);
    primaryImage.setAttribute('srcset', responsiveSrcset);
    primaryImage.setAttribute('data-src', imageUrl);
    primaryImage.setAttribute('data-srcset', responsiveSrcset);
  }

  function updateCardLinksForVariant(card, variantUrl) {
    if (!variantUrl) return;
    var links = card.querySelectorAll('[data-tall-owl-random-scent-link]');
    Array.prototype.forEach.call(links, function (link) {
      link.setAttribute('href', variantUrl);
    });
  }

  function updateScentLabel(card, scentLabel) {
    if (!scentLabel) return;
    var note = card.querySelector('[data-tall-owl-scent-note]');
    if (!note) return;

    var scentCount = Number(note.getAttribute('data-scent-count'));
    var countText = Number.isFinite(scentCount) && scentCount > 1 ? String(Math.round(scentCount)) + ' scents' : '';
    var scentValueLabel = note.querySelector('[data-tall-owl-current-scent-value]');
    var countLabel = note.querySelector('[data-tall-owl-scent-count-label]');
    var currentLabel = note.querySelector('[data-tall-owl-current-scent-label]');
    var currentText = 'Showing ' + scentLabel;

    if (countLabel || currentLabel || scentValueLabel) {
      if (countLabel) countLabel.textContent = countText;
      if (currentLabel) currentLabel.textContent = currentText;
      if (scentValueLabel) scentValueLabel.textContent = scentLabel;

      var ariaLabel = countText ? countText + '. ' + currentText : currentText;
      note.setAttribute('aria-label', ariaLabel);
      return;
    }

    note.textContent = countText ? countText + ' . ' + currentText : currentText;
  }

  function applyRotatingScentVariant(card, variant) {
    if (!card || !variant) return;
    updateCardLinksForVariant(card, variant.url || '');
    updateCardImageForVariant(card, variant.image || '');
    updateScentLabel(card, variant.scent || '');
  }

  function initRotatingScentCards(scope) {
    var root = scope || document;
    var cards = [];

    if (root.nodeType === 1 && root.matches('[data-tall-owl-random-scent-card="true"]')) {
      cards.push(root);
    }
    if (root.querySelectorAll) {
      cards = cards.concat(
        Array.prototype.slice.call(root.querySelectorAll('[data-tall-owl-random-scent-card="true"]'))
      );
    }

    cards.forEach(function (card) {
      if (card.getAttribute('data-tall-owl-random-scent-ready') === 'true') return;

      var productId = (card.getAttribute('data-product-id') || '').trim();
      var dataNode = card.querySelector('script[data-tall-owl-random-scent-variants]');
      var variants = parseJsonData(dataNode ? dataNode.textContent : '');
      if (!Array.isArray(variants) || variants.length < 2) {
        card.setAttribute('data-tall-owl-random-scent-ready', 'true');
        return;
      }

      var selectedIndex = getRotatingScentIndex(productId || 'unknown', variants.length);
      applyRotatingScentVariant(card, variants[selectedIndex]);
      card.setAttribute('data-tall-owl-random-scent-ready', 'true');
    });
  }

  function tallOwlCartFeedbackHost() {
    var drawer = document.querySelector('#CartDrawer');
    return drawer && drawer.classList.contains('drawer--is-open')
      ? drawer.querySelector('.drawer__fixed-header') || drawer
      : document.body;
  }

  function moveTallOwlCartFeedback() {
    var feedback = document.querySelector('.tall-owl-toast[data-tall-owl-cart-feedback]');
    if (!feedback) return;
    var host = tallOwlCartFeedbackHost();
    if (feedback.parentNode !== host) host.appendChild(feedback);
  }

  document.addEventListener('drawerOpen.CartDrawer', moveTallOwlCartFeedback);
  document.addEventListener('drawerClose.CartDrawer', moveTallOwlCartFeedback);

  function clearTallOwlCartFeedback() {
    if (tallOwlCartRecoveryRequired) return;
    var feedback = document.querySelector('.tall-owl-toast[data-tall-owl-cart-feedback]');
    if (feedback && feedback.parentNode) feedback.parentNode.removeChild(feedback);
  }
  window.tallOwlClearCartFeedback = clearTallOwlCartFeedback;

  function showToast(message, isError) {
    if (!message) return;
    if (tallOwlCartRecoveryRequired) message = 'Your cart may have changed. Reload this page to check it before adding or changing items.';
    var existing = document.querySelector('.tall-owl-toast');
    if (tallOwlCartRecoveryRequired && existing && existing.hasAttribute('data-tall-owl-cart-recovery')) return;
    if (existing) existing.parentNode.removeChild(existing);
    var el = document.createElement('div');
    el.className = 'tall-owl-toast';
    if (isError || tallOwlCartRecoveryRequired) {
      el.setAttribute('data-tall-owl-cart-feedback', 'error');
      el.setAttribute('role', 'alert');
      el.setAttribute('aria-atomic', 'true');
    } else {
      el.setAttribute('role', 'status');
    }
    var reload;
    if (tallOwlCartRecoveryRequired) {
      el.setAttribute('data-tall-owl-cart-recovery', 'true');
      reload = document.createElement('a');
      reload.href = window.location.href;
      reload.textContent = 'Reload and check cart';
      reload.setAttribute('tabindex', '0');
      reload.style.color = 'inherit';
      reload.style.textDecoration = 'underline';
      reload.style.display = 'block';
    }
    (isError || tallOwlCartRecoveryRequired ? tallOwlCartFeedbackHost() : document.body).appendChild(el);
    // Mount an empty live region first, then populate it on the next frame so
    // the first failure is announced as well as the later updates.
    window.requestAnimationFrame(function () {
      el.textContent = message;
      if (reload) el.appendChild(reload);
      el.classList.add('is-visible');
    });
    if (isError || tallOwlCartRecoveryRequired) return;
    window.setTimeout(function () {
      el.classList.remove('is-visible');
      window.setTimeout(function () {
        if (el.parentNode) el.parentNode.removeChild(el);
      }, 300);
    }, 4000);
  }
  function parsePositiveInt(value) {
    var parsed = parseInt(value, 10);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : 0;
  }
  function addToCart(variantId, quantity) {
    var addAsker = document.activeElement && document.activeElement !== document.body ? document.activeElement : null;
    if (!variantId) return Promise.resolve(null);
    var qty = parsePositiveInt(quantity);
    if (!qty) qty = 1;

    // Route through the global cart-write queue so this add never collides with
    // an in-flight BOGO free-unit add or gift add/remove (Shopify drops one of
    // two concurrent /cart/* writes). Events dispatch after the write commits.
    return tallOwlQueueCartWrite(function () {
      return tallOwlCartRequest('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(tallOwlCartSectionRequest({ id: Number(variantId), quantity: qty }))
      })
        .then(function (response) {
          if (!response.ok) {
            var error = new Error('The requested quantity could not be confirmed. Check your cart before adding more.');
            error.cartRejected = true;
            return tallOwlReadFailedAdd(error);
          }
          return response.json();
        })
        .then(function (product) {
          return tallOwlFinishPaidAdd(undefined, product && product.sections).then(function (cart) {
            if (cart) document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
            document.dispatchEvent(
              new CustomEvent('ajaxProduct:added', {
                detail: { product: product, cart: cart, addToCartBtn: addAsker, returnFocus: addAsker }
              })
            );
            document.dispatchEvent(new CustomEvent('cart:build', { detail: { cart: cart } }));
            return product;
          });
        }).catch(function (error) {
          if ((error.cartRejected || error.writeUncertain) && !error.cartReadVerified) return tallOwlReadFailedAdd(error);
          throw error;
        });
    }).catch(function (error) {
      showToast(error && error.cartRejected
        ? 'The requested quantity could not be confirmed. Check your cart before adding more.'
        : 'We could not confirm this addition. Check your cart before adding more.', true);
      throw error;
    });
  }
  function normalizeText(value) {
    return String(value || '').trim().toLowerCase();
  }
  // Add the exact replacement before touching the original. Every phase is
  // verified against the whole-cart snapshot, including private properties and
  // selling plans. A rejected/partial replacement is rolled back before retry;
  // an uncertain transport closes the write gate instead of risking a replay.
  function tallOwlSwapCartVariant(key, newId) {
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    var before;
    var original;
    var originalIdentity;
    var replacementIdentity;
    var quantity;

    function lineIdentity(line, variantId) {
      var properties = line.properties || {};
      var sortedProperties = Object.keys(properties).sort().map(function (name) { return [name, properties[name]]; });
      var plan = line.selling_plan_allocation && line.selling_plan_allocation.selling_plan;
      return JSON.stringify([String(variantId || line.variant_id || line.id), sortedProperties, String(plan && plan.id || '')]);
    }
    function quantities(cart) {
      if (!cart || !Array.isArray(cart.items)) throw new Error('Unable to verify cart');
      return cart.items.reduce(function (totals, line) {
        if (!line.key || !Number.isInteger(Number(line.quantity)) || Number(line.quantity) <= 0) {
          throw new Error('Unable to verify cart item');
        }
        var identity = lineIdentity(line);
        totals[identity] = (totals[identity] || 0) + Number(line.quantity);
        return totals;
      }, {});
    }
    function hasQuantities(cart, expected) {
      var actual = quantities(cart);
      var keys = Object.keys(actual).concat(Object.keys(expected));
      return keys.every(function (identity) { return (actual[identity] || 0) === (expected[identity] || 0); });
    }
    function readCart() {
      return tallOwlCartRequest(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (response) { if (!response.ok) throw new Error('Unable to read cart'); return response.json(); })
        .then(function (cart) { quantities(cart); return cart; });
    }
    function post(path, body) {
      return tallOwlCartRequest(root + path, {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
      }).then(function (response) {
        if (!response.ok) { var error = new Error('Cart change was rejected'); error.cartRejected = true; error.status = response.status; throw error; }
        return response.json();
      });
    }
    function addBody(id, amount) {
      var body = { id: Number(id), quantity: amount, properties: original.properties || {} };
      var plan = original.selling_plan_allocation && original.selling_plan_allocation.selling_plan;
      if (plan && plan.id) body.selling_plan = plan.id;
      return body;
    }
    function setIdentityQuantity(cart, identity, target) {
      var current = quantities(cart)[identity] || 0;
      if (current < target) throw new Error('Cart changed during recovery');
      if (current === target) return Promise.resolve(cart);
      var line = cart.items.filter(function (item) { return lineIdentity(item) === identity; })[0];
      if (!line) throw new Error('Unable to identify cart item');
      var amount = Number(line.quantity);
      return post('cart/change.js', { id: line.key, quantity: Math.max(0, amount - (current - target)) })
        .then(function (updated) {
          if ((quantities(updated)[identity] || 0) >= current) throw new Error('Cart quantity did not change');
          return setIdentityQuantity(updated, identity, target);
        });
    }
    function recover(error) {
      if (!before) throw error;
      if (tallOwlCartRecoveryRequired) {
        // A read can explain the actual state, but can never prove a timed-out
        // server write will not arrive later. It therefore cannot reopen writes.
        return readCart().then(function (cart) { error.cart = cart; throw error; }, function () { throw error; });
      }
      return readCart().then(function (cart) {
        var expected = quantities(before);
        var actual = quantities(cart);
        var originalMissing = (expected[originalIdentity] || 0) - (actual[originalIdentity] || 0);
        if (originalMissing < 0 || (actual[replacementIdentity] || 0) < (expected[replacementIdentity] || 0)) {
          throw new Error('Cart changed during recovery');
        }
        // Restore the paid original before removing any replacement quantity.
        var restored = originalMissing > 0
          ? post('cart/add.js', addBody(original.variant_id || original.id, originalMissing)).then(readCart)
          : Promise.resolve(cart);
        return restored.then(function (restoredCart) {
          if ((quantities(restoredCart)[originalIdentity] || 0) !== (expected[originalIdentity] || 0)) {
            throw new Error('Original cart item could not be restored');
          }
          return setIdentityQuantity(restoredCart, replacementIdentity, expected[replacementIdentity] || 0);
        }).then(readCart).then(function (restoredCart) {
          if (!hasQuantities(restoredCart, expected)) throw new Error('Cart recovery could not be confirmed');
          error.cart = restoredCart;
          error.cartRestored = true;
          throw error;
        });
      }).catch(function (recoveryError) {
        if (recoveryError === error) throw error;
        tallOwlRequireCartRecovery(recoveryError);
        throw recoveryError;
      });
    }

    return readCart().then(function (cart) {
      before = cart;
      original = cart.items.filter(function (item) { return item.key === key; })[0];
      if (!original) { before = null; throw new Error('Your cart changed. Choose the scent again.'); }
      quantity = Number(original.quantity);
      originalIdentity = lineIdentity(original);
      replacementIdentity = lineIdentity(original, newId);
      if (originalIdentity === replacementIdentity) return cart;
      return post('cart/add.js', addBody(newId, quantity)).then(readCart).then(function (withReplacement) {
        var expected = quantities(before);
        expected[replacementIdentity] = (expected[replacementIdentity] || 0) + quantity;
        if (!hasQuantities(withReplacement, expected)) throw new Error('Replacement cart item could not be confirmed');
        return setIdentityQuantity(withReplacement, originalIdentity, (expected[originalIdentity] || 0) - quantity);
      }).then(readCart).then(function (updatedCart) {
        var expected = quantities(before);
        expected[originalIdentity] -= quantity;
        expected[replacementIdentity] = (expected[replacementIdentity] || 0) + quantity;
        if (!hasQuantities(updatedCart, expected)) throw new Error('Scent change could not be confirmed');
        return updatedCart;
      });
    }).catch(recover);
  }

  function initTallOwlCartVariantSwap() {
    if (document.documentElement.hasAttribute('data-tall-owl-cart-variant-swap')) return;
    document.documentElement.setAttribute('data-tall-owl-cart-variant-swap', 'true');

    document.addEventListener('change', function (event) {
      var select = event.target.closest('[data-tall-owl-cart-variant-swap]');
      if (!select || select.disabled) return;
      var key = select.getAttribute('data-key');
      var newId = Number(select.value);
      if (!key || !newId) return;
      select.disabled = true;
      select.setAttribute('aria-busy', 'true');

      tallOwlQueueCartWrite(function () { return tallOwlSwapCartVariant(key, newId); })
        .then(function (cart) {
          clearTallOwlCartFeedback();
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
        }).catch(function (error) {
          if (error.cart) document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: error.cart } }));
          showToast(error.recoveryRequired
            ? 'Reload this page to check your cart before making another change.'
            : error.cartRestored
              ? 'Your original item is still in the cart. Please choose the scent again.'
              : 'Your cart changed. Check your cart and choose the scent again.', true);
        }).then(function () {
          select.disabled = false;
          select.removeAttribute('aria-busy');
          document.dispatchEvent(new CustomEvent('cart:build'));
        });
    });
  }

  function initCartRemoveLinkGuard() {
    if (document.documentElement.hasAttribute('data-tall-owl-cart-remove-guard')) return;
    document.documentElement.setAttribute('data-tall-owl-cart-remove-guard', 'true');

    document.addEventListener(
      'click',
      function (event) {
        var removeLink = event.target.closest('.cart__remove a[href*="/cart/change"]');
        if (!removeLink) return;

        var href = String(removeLink.getAttribute('href') || '');
        var cartItem = removeLink.closest('.cart__item');
        var form = removeLink.closest('form');
        var location = form ? String(form.getAttribute('data-location') || '').trim() : '';
        var qtyWrapper = cartItem ? cartItem.querySelector('.js-qty__wrapper') : null;
        var key = cartItem ? String(cartItem.getAttribute('data-key') || '').trim() : '';

        if (!key) {
          var hrefMatch = href.match(/[?&]id=([^&#]+)/i);
          key = hrefMatch && hrefMatch[1] ? decodeURIComponent(hrefMatch[1]) : '';
        }

        if (!key) return;

        event.preventDefault();

        if (removeLink.getAttribute('aria-disabled') === 'true') return;
        var removeState = {
          control: removeLink,
          ariaDisabled: removeLink.getAttribute('aria-disabled'),
          loading: removeLink.classList.contains('is-loading')
        };
        removeLink.setAttribute('aria-disabled', 'true');
        removeLink.classList.add('is-loading');

        if (qtyWrapper) {
          qtyWrapper.classList.add('is-loading');
        }

        if (location) {
          document.dispatchEvent(
            new CustomEvent('cart:quantity' + '.cart-' + location, {
              detail: [key, 0, qtyWrapper, removeState]
            })
          );
          return;
        }

        tallOwlQueueCartWrite(function () {
          return theme.cart.changeItem(key, 0);
        })
          .then(function (cart) {
            var parsedCart = JSON.parse(cart);
            document.dispatchEvent(
              new CustomEvent('cart:updated', {
                detail: {
                  cart: parsedCart
                }
              })
            );
            document.dispatchEvent(new CustomEvent('cart:build'));
          })
          .catch(function () {
            removeLink.removeAttribute('aria-disabled');
            removeLink.classList.remove('is-loading');
            if (qtyWrapper) {
              qtyWrapper.classList.remove('is-loading');
            }
            showToast('Unable to update your cart right now.', true);
          });
      },
      true
    );
  }
  function initTallOwlCartCrossSellAdd() {
    if (document.documentElement.hasAttribute('data-tall-owl-cart-xs-bound')) return;
    document.documentElement.setAttribute('data-tall-owl-cart-xs-bound', 'true');
    var root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
    var xsEligibleHandles = {
      'whipped-tallow': true,
      'tallow-body-balm': true,
      'tallow-trio-bundle': true,
      'eye-serum': true,
      'freedom-balm': true,
      'nourishing-oil': true,
      'baby-balm': true
    };
    var xsRefreshToken = 0;

    function xsFormatMoney(cents) {
      if (window.Shopify && Shopify.formatMoney && window.theme && theme.settings) {
        return Shopify.formatMoney(cents, theme.settings.moneyFormat);
      }
      // Match the server's shop money format ("$38", not "$38.00") so the
      // re-rendered cross-sell price does not wrap onto a new line and shift rows.
      if (window.theme && theme.Currency && theme.Currency.formatMoney && theme.settings && theme.settings.moneyFormat) {
        return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
      }
      return '$' + (Number(cents || 0) / 100).toFixed(2);
    }

    function xsEsc(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
    }

    function fetchCrossSellCart() {
      return tallOwlCartRequest(root + 'cart.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      }).then(function (response) {
        if (!response.ok) throw new Error('Cart read failed');
        return response.json();
      });
    }

    function crossSellVariantQuantity(cart, id) {
      return (cart.items || []).reduce(function (quantity, cartItem) {
        return String(cartItem.variant_id) === String(id)
          ? quantity + Number(cartItem.quantity || 0)
          : quantity;
      }, 0);
    }

    function crossSellBogoSavings(cart) {
      return (cart.items || []).reduce(function (total, cartItem) {
        return total + (cartItem.line_level_discount_allocations || []).reduce(
          function (lineTotal, allocation) {
            var application = allocation.discount_application || {};
            var title = String(allocation.title || application.title || '').toLowerCase();
            return title.indexOf('bogo 50') !== -1 ||
              title.indexOf('bogo free') !== -1 ||
              title.indexOf('bogos-') !== -1 ||
              title === 'bogo' ||
              title.indexOf('pair savings') !== -1 ||
              title.indexOf('2nd one 50') !== -1
              ? lineTotal + Number(allocation.amount || 0)
              : lineTotal;
          },
          0
        );
      }, 0);
    }

    function xsIsBogoDiscountTitle(title) {
      /* Keep in lockstep with isBogoDiscountTitle in tall-owl-pair-builder.js:
         legacy admin titles plus the customer-safe rename candidates, so a
         checkout-label rename never breaks the drawer economics. */
      var normalized = String(title || '').toLowerCase();
      return normalized.indexOf('bogo 50') !== -1 ||
        normalized.indexOf('bogo free') !== -1 ||
        normalized.indexOf('bogos-') !== -1 ||
        normalized === 'bogo' ||
        normalized.indexOf('pair savings') !== -1 ||
        normalized.indexOf('2nd one 50') !== -1;
    }

    function xsHasOtherDiscount(cart) {
      var cartLevelDiscount = (cart && cart.cart_level_discount_applications || []).some(
        function (application) {
          return Number(application.total_allocated_amount || 0) > 0 &&
            !xsIsBogoDiscountTitle(application.title);
        }
      );
      if (cartLevelDiscount) return true;

      return (cart && cart.items || []).some(function (cartItem) {
        return (cartItem.line_level_discount_allocations || []).some(function (allocation) {
          var application = allocation.discount_application || {};
          return Number(allocation.amount || 0) > 0 &&
            !xsIsBogoDiscountTitle(allocation.title || application.title);
        });
      });
    }

    function xsEligibleUnitPrices(cart) {
      var prices = [];
      (cart && cart.items ? cart.items : []).forEach(function (cartItem) {
        var handle = String(cartItem.handle || cartItem.product_handle || '').toLowerCase();
        if (!xsEligibleHandles[handle]) return;
        var price = Number(cartItem.original_price || cartItem.price || 0);
        var quantity = Math.max(0, Number(cartItem.quantity || 0));
        for (var index = 0; index < quantity; index += 1) prices.push(price);
      });
      return prices;
    }

    function xsProjectedSavings(prices) {
      return prices
        .map(function (price) { return Math.max(0, Number(price || 0)); })
        .sort(function (left, right) { return right - left; })
        .reduce(function (savings, price, index) {
          return index % 2 === 1 ? savings + tallOwlPairOfferSaving(price) : savings;
        }, 0);
    }

    function renderCrossSellEconomics(item, cart) {
      if (!item || !cart) return;
      var priceBox = item.querySelector('[data-tall-owl-cart-xs-pricebox]');
      var button = item.querySelector('[data-tall-owl-cart-xs-add]');
      var candidateCents = Number(item.getAttribute('data-candidate-cents') || 0);
      if (!priceBox || !button || candidateCents <= 0) return;

      var currentPrices = xsEligibleUnitPrices(cart);
      var beforeSavings = xsProjectedSavings(currentPrices);
      var afterSavings = xsProjectedSavings(currentPrices.concat([candidateCents]));
      var incrementalSavings = Math.max(0, afterSavings - beforeSavings);
      var effectiveCents = Math.max(0, candidateCents - incrementalSavings);
      var unpairedCents = Number(item.getAttribute('data-unpaired-cents') || 0);
      var hasOtherDiscount = xsHasOtherDiscount(cart);

      button.setAttribute('data-pair-savings-cents', String(incrementalSavings));
      button.setAttribute('data-cart-increase-cents', String(effectiveCents));
      if (unpairedCents > 0) {
        button.setAttribute(
          'data-pair-total-cents',
          String(candidateCents + unpairedCents - incrementalSavings)
        );
      }
      priceBox.innerHTML =
        (incrementalSavings > 0
          ? '<s class="tall-owl-cart-xs__was">' + xsEsc(xsFormatMoney(candidateCents)) + '</s> ' +
            '<strong class="tall-owl-cart-xs__now" data-tall-owl-cart-xs-price>' +
            xsEsc(xsFormatMoney(effectiveCents)) + '</strong> '
          : '<span data-tall-owl-cart-xs-price>' + xsEsc(xsFormatMoney(candidateCents)) + '</span> ') +
        /* Mirror the server-rendered pricebox phrasing exactly - the
           copy canon bans "BOGO" on customer surfaces, and the drawer
           must not flip wording between Liquid and JS renders. */
        '<span class="tall-owl-cart-xs__pairnote">after pair savings</span> ' +
        '<span class="tall-owl-cart-xs__pairnote">pair total ' +
        xsEsc(xsFormatMoney(candidateCents + unpairedCents - incrementalSavings)) +
        ' &middot; save ' +
        xsEsc(xsFormatMoney(incrementalSavings)) +
        (hasOtherDiscount ? ' before other discounts' : '') +
        '</span>';
    }

    function refreshCrossSellEconomics(cart) {
      var pairableItems = document.querySelectorAll(
        '[data-tall-owl-cart-xs] [data-tall-owl-xs-pairable]'
      );
      if (!pairableItems.length) return Promise.resolve(null);
      var token = ++xsRefreshToken;
      var cartPromise = cart ? Promise.resolve(cart) : fetchCrossSellCart();
      return cartPromise.then(function (freshCart) {
        if (token !== xsRefreshToken) return freshCart;
        pairableItems.forEach(function (item) {
          renderCrossSellEconomics(item, freshCart);
        });
        return freshCart;
      }).catch(function () {
        return null;
      });
    }

    function restoreCrossSellVariant(beforeCart, variantId) {
      var expected = {}; expected[String(variantId)] = 1;
      return tallOwlRestoreCartVariants(beforeCart, expected);
    }

    // Keep the row's price + the add button's variant in sync when the shopper
    // picks a scent/size. Delegated so it survives every cart-drawer re-render.
    // Pairable rows re-run Version E's whole-cart allocation after every change.
    document.addEventListener('change', function (event) {
      var select = event.target.closest('[data-tall-owl-cart-xs-scent]');
      if (!select) return;
      var item = select.closest('.tall-owl-cart-xs__item');
      if (!item) return;
      var opt = select.options[select.selectedIndex];
      if (!opt) return;
      var button = item.querySelector('[data-tall-owl-cart-xs-add]');
      if (button && opt.value) button.setAttribute('data-variant-id', opt.value);

      // The selected option already owns the row's exact SKU. Keep its
      // photograph and label-derived ground together before updating prices.
      var photoSurface = item.querySelector('.tall-owl-cart-xs__media');
      var photoImage = photoSurface ? photoSurface.querySelector('img') : null;
      var photoSrc = opt.getAttribute('data-photo-src');
      var photoGround = opt.getAttribute('data-photo-ground');
      if (photoImage) {
        if (photoSrc) {
          var photoSrcset = opt.getAttribute('data-photo-srcset') || photoSrc;
          photoImage.setAttribute('srcset', photoSrcset);
          photoImage.setAttribute('data-srcset', photoSrcset);
          photoImage.setAttribute('data-src', photoSrc);
          photoImage.src = photoSrc;
          photoImage.alt = opt.getAttribute('data-photo-alt') || '';
          photoImage.style.visibility = '';
          photoImage.removeAttribute('aria-hidden');
          if (photoGround) photoSurface.style.setProperty('--to-photo-ground', photoGround);
        } else if (opt.hasAttribute('data-photo-src')) {
          // A future variant without exact media must not retain another SKU's photo.
          photoImage.style.visibility = 'hidden';
          photoImage.setAttribute('aria-hidden', 'true');
          photoSurface.style.removeProperty('--to-photo-ground');
        }
      }
      var photoLink = item.querySelector('.tall-owl-cart-xs__link');
      var photoHref = opt.getAttribute('data-photo-href');
      if (photoLink && photoHref) photoLink.href = photoHref;

      var priceBox = item.hasAttribute('data-tall-owl-xs-pairable')
        ? item.querySelector('[data-tall-owl-cart-xs-pricebox]')
        : null;
      var cents = Number(opt.getAttribute('data-cents') || 0);
      if (priceBox && cents > 0) {
        item.setAttribute('data-candidate-cents', String(cents));
        refreshCrossSellEconomics();
        return;
      }

      var priceEl = item.querySelector('[data-tall-owl-cart-xs-price]');
      var priceText = opt.getAttribute('data-price');
      if (priceEl && priceText) priceEl.textContent = priceText;
    });

    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-tall-owl-cart-xs-add]');
      if (!button || button.disabled) return;
      event.preventDefault();

      // Resolve the variant at click time, preferring the scent picker's current
      // value over the button default (guards against a change event that hasn't
      // fired yet, e.g. a fast tap right after picking on mobile).
      var item = button.closest('.tall-owl-cart-xs__item');
      var scentSelect = item ? item.querySelector('[data-tall-owl-cart-xs-scent]') : null;
      var variantId = scentSelect && scentSelect.value ? scentSelect.value : button.getAttribute('data-variant-id');
      if (!variantId) return;

      var label = button.querySelector('.tall-owl-cart-xs__add-label');
      var originalLabelText = label ? label.textContent : '';
      var completesPair = button.hasAttribute('data-tall-owl-cart-complete-pair');
      var baseVariantId = String(button.getAttribute('data-base-variant-id') || '');
      var pairTotalCents = Number(button.getAttribute('data-pair-total-cents') || 0);
      var pairSavingsCents = Number(button.getAttribute('data-pair-savings-cents') || 0);

      if (completesPair) {
        document.dispatchEvent(
          new CustomEvent('tallowl:pair-click', {
            detail: {
              pair_type: baseVariantId === String(variantId) ? 'same_variant' : 'cart_completion',
              placement: 'cart',
              product_id: String(button.getAttribute('data-product-id') || ''),
              product_handle: String(button.getAttribute('data-product-handle') || ''),
              variant_ids: [baseVariantId, String(variantId)],
              pair_total_cents: pairTotalCents,
              pair_savings_cents: pairSavingsCents
            }
          })
        );
      }

      button.disabled = true;
      button.classList.add('is-loading');
      if (scentSelect) scentSelect.disabled = true;
      if (label) label.textContent = 'Adding...';

      tallOwlQueueCartWrite(function () {
        var beforeCart = null;
        var addedProduct = null;
        var beforeQuantity = 0;
        var beforeSavings = 0;
        var addAttempted = false;
        var rollbackAttempted = false;
        var prepare = completesPair ? fetchCrossSellCart() : Promise.resolve(null);

        function rejectAfterCrossSellRollback(message) {
          rollbackAttempted = true;
          return restoreCrossSellVariant(
            beforeCart,
            variantId,
            addedProduct && addedProduct.key
          ).then(function () {
            var error = new Error(message);
            error.rolledBack = true;
            throw error;
          }, function () {
            var error = new Error(message);
            error.rollbackFailed = true;
            throw error;
          });
        }

        return prepare
          .then(function (cart) {
            beforeCart = cart;
            if (cart) {
              beforeQuantity = crossSellVariantQuantity(cart, variantId);
              beforeSavings = crossSellBogoSavings(cart);
            }
            addAttempted = true;
            return tallOwlCartRequest(root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify(completesPair
                ? tallOwlCartStateRequest({ id: Number(variantId), quantity: 1 }, beforeCart)
                : tallOwlCartSectionRequest({ id: Number(variantId), quantity: 1 }, beforeCart))
            });
          })
          .then(function (response) {
            if (!response.ok) {
              var error = new Error('The requested quantity could not be confirmed');
              error.cartRejected = true;
              if (completesPair) throw error;
              return tallOwlReadFailedAdd(error);
            }
            return response.json();
          })
          .then(function (product) {
            addedProduct = product;
            if (!completesPair) return null;
            return tallOwlReadPaidCartState(product, fetchCrossSellCart);
          })
          .then(function (afterCart) {
            if (completesPair) {
              var confirmed =
                crossSellVariantQuantity(afterCart, variantId) - beforeQuantity === 1 &&
                crossSellBogoSavings(afterCart) > beforeSavings;
              if (!confirmed) {
                return rejectAfterCrossSellRollback('Pair completion was not confirmed');
              }
            }
            return tallOwlFinishPaidAdd(afterCart, addedProduct && addedProduct.sections);
          })
          .then(function (afterCart) {
            if (completesPair) {
              document.dispatchEvent(
                new CustomEvent('tallowl:pair-added', {
                  detail: {
                    pair_type: baseVariantId === String(variantId) ? 'same_variant' : 'cart_completion',
                    placement: 'cart',
                    product_id: String(button.getAttribute('data-product-id') || ''),
                    product_handle: String(button.getAttribute('data-product-handle') || ''),
                    variant_ids: [baseVariantId, String(variantId)],
                    pair_total_cents: pairTotalCents,
                    pair_savings_cents: pairSavingsCents,
                    cart_total_cents: Number(afterCart.total_price || 0)
                  }
                })
              );
              document.dispatchEvent(
                new CustomEvent('cart:updated', { detail: { cart: afterCart } })
              );
            }
            if (!completesPair && afterCart) {
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: afterCart } }));
            }
            if (label) label.textContent = 'Added';
            // ajaxProduct:added keeps the theme's add-to-cart plumbing (drawer
            // refresh, gift sync) in the loop; the drawer is already open here.
            document.dispatchEvent(
              new CustomEvent('ajaxProduct:added', {
                detail: { product: addedProduct, cart: afterCart, addToCartBtn: button, returnFocus: button }
              })
            );
            document.dispatchEvent(new CustomEvent('cart:build', { detail: { cart: afterCart } }));
          })
          .catch(function (error) {
            if (!completesPair && (error.cartRejected || error.writeUncertain) && !error.cartReadVerified) return tallOwlReadFailedAdd(error);
            if (completesPair && addAttempted && beforeCart && !rollbackAttempted &&
                !(error && error.recoveryRequired) && !tallOwlCartRecoveryRequired) {
              return rejectAfterCrossSellRollback(error && error.message
                ? error.message
                : 'Pair completion was not confirmed');
            }
            throw error;
          });
      })
        .catch(function (error) {
          button.disabled = false;
          button.classList.remove('is-loading');
          if (scentSelect) scentSelect.disabled = false;
          if (label) label.textContent = originalLabelText || '+ Add';
          var message = tallOwlCartRecoveryRequired
            ? 'Reload this page to check your cart before making another change.'
            : completesPair
              ? error && error.rolledBack
                ? 'We could not confirm the pair. Your prior cart was restored; please try again.'
                : 'We could not confirm the pair. Please review your cart before trying again.'
              : 'We could not confirm this addition. Review your cart before adding more.';
          showToast(message, true);
        });
    });

    document.addEventListener('cart:markup:updated', function () {
      refreshCrossSellEconomics();
    });
    document.addEventListener('cart:updated', function (event) {
      refreshCrossSellEconomics(event.detail && event.detail.cart);
    });
    refreshCrossSellEconomics();
  }

  function initTallOwlPdpPairModules(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var modules = scope.querySelectorAll('[data-tall-owl-pair-module]');
    var homepageSections = Array.prototype.slice.call(
      scope.querySelectorAll('[data-tall-owl-pick-pair]')
    );
    if (scope.matches && scope.matches('[data-tall-owl-pick-pair]')) {
      homepageSections.unshift(scope);
    }

    function formatPairMoney(cents) {
      if (window.Shopify && Shopify.formatMoney && window.theme && theme.settings) {
        return Shopify.formatMoney(cents, theme.settings.moneyFormat);
      }
      return '$' + (Number(cents || 0) / 100).toFixed(2);
    }

    function fetchPairCart() {
      var route = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
      return tallOwlCartRequest(route + 'cart.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      }).then(function (response) {
        if (!response.ok) throw new Error('Unable to read cart');
        return response.json();
      });
    }

    function quantityForVariant(cart, variantId) {
      return (cart.items || []).reduce(function (total, item) {
        return String(item.variant_id) === String(variantId) ? total + Number(item.quantity || 0) : total;
      }, 0);
    }

    function rollbackPairItems(beforeCart, expectedDeltas) {
      return tallOwlRestoreCartVariants(beforeCart, expectedDeltas);
    }

    function updatePairModule(module, variant) {
      if (!module || !variant) return;

      var variantId = String(variant.id || '');
      var price = Number(variant.price || 0);
      var available = variant.available !== false;
      module.setAttribute('data-selected-variant-id', variantId);
      module.setAttribute('data-selected-variant-price', String(price));
      module.setAttribute('data-selected-variant-available', available ? 'true' : 'false');

      var variantLabel = module.querySelector('[data-tall-owl-pair-variant-label]');
      if (variantLabel) variantLabel.textContent = variant.public_title || variant.title || '';

      var sameOffer = module.querySelector('[data-tall-owl-pair-offer="same"]');
      if (sameOffer) {
        var sameTotal = price + Math.floor(price * (100 - tallOwlPairOfferPercent()) / 100);
        var sameSavings = tallOwlPairOfferSaving(price);
        var sameCopy = sameOffer.querySelector('[data-tall-owl-pair-copy]');
        var sameButton = sameOffer.querySelector('[data-tall-owl-pair-add]');
        if (sameCopy) {
          sameCopy.textContent =
            '2 for ' +
            formatPairMoney(sameTotal) +
            ' — save ' +
            formatPairMoney(sameSavings) +
            (sameTotal >= 5000 ? ' + free shipping + free Lip Balm' : '');
        }
        if (sameButton) {
          sameButton.setAttribute('data-pair-total-cents', String(sameTotal));
          sameButton.setAttribute('data-pair-savings-cents', String(sameSavings));
          sameButton.disabled = !available;
        }
      }

      var freedomOffer = module.querySelector('[data-tall-owl-pair-offer="freedom"]');
      if (freedomOffer) {
        var freedomPrice = Number(module.getAttribute('data-freedom-variant-price') || 0);
        var mixedSavings = tallOwlPairOfferSaving(Math.min(price, freedomPrice));
        var mixedTotal = price + freedomPrice - mixedSavings;
        var mixedCopy = freedomOffer.querySelector('[data-tall-owl-pair-copy]');
        var mixedButton = freedomOffer.querySelector('[data-tall-owl-pair-add]');
        if (mixedCopy) {
          mixedCopy.textContent =
            formatPairMoney(mixedTotal) +
            ' — save ' +
            formatPairMoney(mixedSavings) +
            ' + free shipping + free Lip Balm';
        }
        if (mixedButton) {
          mixedButton.setAttribute('data-pair-total-cents', String(mixedTotal));
          mixedButton.setAttribute('data-pair-savings-cents', String(mixedSavings));
          mixedButton.disabled = !available;
        }
      }
    }

    function bindPairModule(module) {
      if (!module || module.getAttribute('data-tall-owl-pair-bound') === 'true') return;
      module.setAttribute('data-tall-owl-pair-bound', 'true');

      var section = module.closest('.product-section');
      var variantsNode = module.querySelector('[data-tall-owl-pair-variants]');
      var variants = [];
      try {
        variants = JSON.parse(variantsNode ? variantsNode.textContent : '[]');
      } catch (error) {
        variants = [];
      }

      if (section) {
        section.addEventListener('variantChange', function (event) {
          var variant = event.detail && event.detail.variant;
          if (variant) updatePairModule(module, variant);
        });
      }

      module.addEventListener('click', function (event) {
        var button = event.target.closest('[data-tall-owl-pair-add]');
        if (!button || button.disabled) return;
        event.preventDefault();

        var selectedId = String(module.getAttribute('data-selected-variant-id') || '');
        var pairType = String(button.getAttribute('data-pair-type') || '');
        var freedomId = String(module.getAttribute('data-freedom-variant-id') || '');
        var selectedVariant = variants.filter(function (variant) {
          return String(variant.id) === selectedId;
        })[0];
        var status = module.querySelector('[data-tall-owl-pair-status]');
        var buttons = module.querySelectorAll('[data-tall-owl-pair-add]');
        var requestItems = [];
        var expectedDeltas = {};

        if (!selectedId || !selectedVariant || selectedVariant.available === false) {
          if (status) status.textContent = 'Choose an available scent and size first.';
          return;
        }

        if (pairType === 'same_variant') {
          requestItems.push({ id: Number(selectedId), quantity: 2 });
          expectedDeltas[selectedId] = 2;
        } else if (pairType === 'freedom_balm' && freedomId) {
          requestItems.push({ id: Number(selectedId), quantity: 1 });
          requestItems.push({ id: Number(freedomId), quantity: 1 });
          expectedDeltas[selectedId] = (expectedDeltas[selectedId] || 0) + 1;
          expectedDeltas[freedomId] = (expectedDeltas[freedomId] || 0) + 1;
        } else {
          if (status) status.textContent = 'This pairing is not available right now.';
          return;
        }

        document.dispatchEvent(
          new CustomEvent('tallowl:pair-click', {
            detail: {
              pair_type: pairType,
              product_id: String(module.getAttribute('data-product-id') || ''),
              product_handle: String(module.getAttribute('data-product-handle') || ''),
              variant_ids: Object.keys(expectedDeltas),
              pair_total_cents: Number(button.getAttribute('data-pair-total-cents') || 0),
              pair_savings_cents: Number(button.getAttribute('data-pair-savings-cents') || 0)
            }
          })
        );

        buttons.forEach(function (pairButton) {
          pairButton.disabled = true;
          pairButton.classList.add('is-loading');
          pairButton.setAttribute('aria-busy', 'true');
        });
        if (status) {
          status.classList.remove('is-error', 'is-success');
          status.textContent = 'Adding both items…';
        }

        var beforeCart;
        var beforeByKey = {};
        var addedItems = [];
        var paidSections;
        var route = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';

        tallOwlQueueCartWrite(function () {
          return fetchPairCart()
            .then(function (cart) {
              beforeCart = cart;
              (cart.items || []).forEach(function (item) {
                beforeByKey[item.key] = Number(item.quantity || 0);
              });
              return tallOwlCartRequest(route + 'cart/add.js', {
                method: 'POST',
                credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify(tallOwlCartStateRequest({ items: requestItems }, beforeCart))
              });
            })
            .then(function (response) {
              if (!response.ok) {
                return rollbackPairItems(beforeCart, expectedDeltas).then(function () {
                  var error = new Error('Pair add was rejected; the prior cart was restored');
                  error.cartRejected = true; error.cartRestored = true; throw error;
                });
              }
              return response.json();
            })
            .then(function (responsePayload) {
              addedItems = responsePayload && responsePayload.items ? responsePayload.items : [];
              paidSections = responsePayload && responsePayload.sections;
              return tallOwlReadPaidCartState(responsePayload, fetchPairCart);
            })
            .then(function (afterCart) {
              var confirmed = Object.keys(expectedDeltas).every(function (variantId) {
                return (
                  quantityForVariant(afterCart, variantId) - quantityForVariant(beforeCart, variantId) ===
                  expectedDeltas[variantId]
                );
              });

              if (!confirmed) {
                return rollbackPairItems(beforeCart, expectedDeltas)
                  .catch(function () {
                    /* The error below asks the shopper to review the cart. */
                  })
                  .then(function () {
                    throw new Error('Pair quantities were not confirmed');
                  });
              }

              return tallOwlFinishPaidAdd(afterCart, paidSections);
            })
            .then(function (afterCart) {
              document.dispatchEvent(
                new CustomEvent('tallowl:pair-added', {
                  detail: {
                    pair_type: pairType,
                    product_id: String(module.getAttribute('data-product-id') || ''),
                    product_handle: String(module.getAttribute('data-product-handle') || ''),
                    variant_ids: Object.keys(expectedDeltas),
                    pair_total_cents: Number(button.getAttribute('data-pair-total-cents') || 0),
                    pair_savings_cents: Number(button.getAttribute('data-pair-savings-cents') || 0),
                    cart_total_cents: Number(afterCart.total_price || 0)
                  }
                })
              );
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: afterCart } }));
              document.dispatchEvent(
                new CustomEvent('ajaxProduct:added', {
                  detail: { product: addedItems[0] || null, cart: afterCart, addToCartBtn: button, returnFocus: button }
                })
              );
              document.dispatchEvent(new CustomEvent('cart:build', { detail: { cart: afterCart } }));
              if (status) {
                status.classList.add('is-success');
                status.textContent = 'Pair added. Your cart confirms both items.';
              }
            }).catch(function (error) {
              if (error.cartRejected && beforeCart && !error.cartRestored) {
                return rollbackPairItems(beforeCart, expectedDeltas).then(function () { error.cartRestored = true; throw error; });
              }
              throw error;
            });
        })
          .catch(function () {
            if (status) {
              status.classList.add('is-error');
              status.textContent = tallOwlCartRecoveryRequired
                ? 'Reload this page to check your cart before making another change.'
                : 'We could not confirm both items. Review your cart before adding more.';
            }
          })
          .then(function () {
            buttons.forEach(function (pairButton) {
              pairButton.classList.remove('is-loading');
              pairButton.removeAttribute('aria-busy');
              pairButton.disabled = module.getAttribute('data-selected-variant-available') !== 'true';
            });
          });
      });
    }

    function bindHomepagePairSection(section) {
      if (!section || section.getAttribute('data-pp-bound') === 'true') return;
      section.setAttribute('data-pp-bound', 'true');

      section.addEventListener('click', function (event) {
        var button = event.target.closest('[data-pp-add]');
        if (!button || button.disabled) return;
        event.preventDefault();

        var baseVariantId = String(button.getAttribute('data-base-variant') || '');
        var addonVariantId = String(button.getAttribute('data-addon-variant') || '');
        var baseVariant = Number(baseVariantId);
        var addonVariant = Number(addonVariantId);
        var card = button.closest('.tall-owl-pair-band__card');
        var status = card ? card.querySelector('[data-pp-status]') : null;
        var buttons = section.querySelectorAll('[data-pp-add]');
        var label = button.querySelector('.tall-owl-pair-band__add-label');
        var originalLabel = label ? label.textContent : 'Add both';
        var expectedDeltas = {};
        var requestItems = [];

        if (!baseVariant || !addonVariant) {
          if (status) {
            status.classList.add('is-error');
            status.textContent = 'This pair is unavailable right now. Please choose products individually.';
          }
          return;
        }

        expectedDeltas[baseVariantId] = (expectedDeltas[baseVariantId] || 0) + 1;
        expectedDeltas[addonVariantId] = (expectedDeltas[addonVariantId] || 0) + 1;
        if (baseVariantId === addonVariantId) {
          requestItems.push({ id: baseVariant, quantity: 2 });
        } else {
          requestItems.push({ id: baseVariant, quantity: 1 });
          requestItems.push({ id: addonVariant, quantity: 1 });
        }

        document.dispatchEvent(
          new CustomEvent('tallowl:pair-click', {
            detail: {
              pair_type: String(button.getAttribute('data-pair-type') || 'mixed_full_size'),
              placement: 'homepage_pair_band',
              product_id: String(button.getAttribute('data-product-id') || ''),
              product_handle: String(button.getAttribute('data-product-handle') || ''),
              variant_ids: Object.keys(expectedDeltas),
              pair_total_cents: Number(button.getAttribute('data-pair-total-cents') || 0),
              pair_savings_cents: Number(button.getAttribute('data-pair-savings-cents') || 0)
            }
          })
        );

        buttons.forEach(function (pairButton) {
          pairButton.disabled = true;
          pairButton.classList.add('is-loading');
          pairButton.setAttribute('aria-busy', 'true');
        });
        if (label) label.textContent = 'Adding…';
        if (status) {
          status.classList.remove('is-error', 'is-success');
          status.textContent = 'Adding and confirming both items…';
        }

        var beforeCart;
        var beforeByKey = {};
        var addedItems = [];
        var paidSections;
        var route = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';

        tallOwlQueueCartWrite(function () {
          return fetchPairCart()
            .then(function (cart) {
              beforeCart = cart;
              (cart.items || []).forEach(function (item) {
                beforeByKey[item.key] = Number(item.quantity || 0);
              });
              return tallOwlCartRequest(route + 'cart/add.js', {
                method: 'POST',
                credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify(tallOwlCartStateRequest({ items: requestItems }, beforeCart))
              });
            })
            .then(function (response) {
              if (!response.ok) {
                return rollbackPairItems(beforeCart, expectedDeltas).then(function () {
                  var error = new Error('Pair add was rejected; the prior cart was restored');
                  error.cartRejected = true; error.cartRestored = true; throw error;
                });
              }
              return response.json();
            })
            .then(function (responsePayload) {
              addedItems = responsePayload && responsePayload.items ? responsePayload.items : [];
              paidSections = responsePayload && responsePayload.sections;
              return tallOwlReadPaidCartState(responsePayload, fetchPairCart);
            })
            .then(function (afterCart) {
              var confirmed = Object.keys(expectedDeltas).every(function (variantId) {
                return (
                  quantityForVariant(afterCart, variantId) - quantityForVariant(beforeCart, variantId) ===
                  expectedDeltas[variantId]
                );
              });

              if (!confirmed) {
                return rollbackPairItems(beforeCart, expectedDeltas)
                  .catch(function () {
                    /* The message below asks the shopper to review the cart. */
                  })
                  .then(function () {
                    throw new Error('Pair quantities were not confirmed');
                  });
              }

              return tallOwlFinishPaidAdd(afterCart, paidSections);
            })
            .then(function (afterCart) {
              document.dispatchEvent(
                new CustomEvent('tallowl:pair-added', {
                  detail: {
                    pair_type: String(button.getAttribute('data-pair-type') || 'mixed_full_size'),
                    placement: 'homepage_pair_band',
                    product_id: String(button.getAttribute('data-product-id') || ''),
                    product_handle: String(button.getAttribute('data-product-handle') || ''),
                    variant_ids: Object.keys(expectedDeltas),
                    pair_total_cents: Number(button.getAttribute('data-pair-total-cents') || 0),
                    pair_savings_cents: Number(button.getAttribute('data-pair-savings-cents') || 0),
                    cart_total_cents: Number(afterCart.total_price || 0)
                  }
                })
              );
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: afterCart } }));
              document.dispatchEvent(
                new CustomEvent('ajaxProduct:added', {
                  detail: { product: addedItems[0] || null, cart: afterCart, addToCartBtn: button, returnFocus: button }
                })
              );
              document.dispatchEvent(new CustomEvent('cart:build', { detail: { cart: afterCart } }));
              if (label) label.textContent = 'Added';
              if (status) {
                status.classList.add('is-success');
                status.textContent = 'Pair added. Your cart confirms both items.';
              }
            }).catch(function (error) {
              if (error.cartRejected && beforeCart && !error.cartRestored) {
                return rollbackPairItems(beforeCart, expectedDeltas).then(function () { error.cartRestored = true; throw error; });
              }
              throw error;
            });
        })
          .catch(function () {
            if (label) label.textContent = originalLabel || 'Add both';
            if (status) {
              status.classList.add('is-error');
              status.textContent = tallOwlCartRecoveryRequired
                ? 'Reload this page to check your cart before making another change.'
                : 'We could not confirm both items. Review your cart before adding more.';
            }
          })
          .then(function () {
            if (label) label.textContent = originalLabel || 'Add both';
            buttons.forEach(function (pairButton) {
              pairButton.classList.remove('is-loading');
              pairButton.removeAttribute('aria-busy');
              pairButton.disabled = false;
            });
          });
      });
    }

    modules.forEach(bindPairModule);
    homepageSections.forEach(bindHomepagePairSection);
  }

  function normalizeTallOwlFullCart() {
    if (!document.body || !document.body.classList.contains('template-cart')) return;
    var form = document.getElementById('CartPageForm');
    if (!form) return;
    var products = form.querySelector('[data-products]');
    if (!products) return;

    // The free Lip Balm closes the list as an ordinary, aligned line (owner,
    // October 1), as in the drawer: no collapsed wrapper of its own.
    var giftItems = [];
    products.querySelectorAll('.cart__item').forEach(function (item) {
      if (item.querySelector('.tall-owl-gift-line')) giftItems.push(item);
    });

    giftItems.forEach(function (item) {
      item.parentNode.appendChild(item);
    });

    var ajaxItems = products.querySelector('.cart__items[data-cart-subtotal]');
    var subtotalCents = ajaxItems ? Number(ajaxItems.getAttribute('data-cart-subtotal') || 0) : 0;
    var subtotal = form.querySelector('[data-tall-owl-mobile-cart-subtotal]');
    if (subtotal && ajaxItems) {
      if (window.Shopify && Shopify.formatMoney && window.theme && theme.settings) {
        subtotal.textContent = Shopify.formatMoney(subtotalCents, theme.settings.moneyFormat);
      } else {
        subtotal.textContent = '$' + (subtotalCents / 100).toFixed(2);
      }
    }

    var bogoSummary = form.querySelector('[data-tall-owl-bogo-summary]');
    var savingsCents = Number(bogoSummary ? bogoSummary.getAttribute('data-bogo-savings-cents') : 0);
    var savings = form.querySelector('[data-tall-owl-mobile-cart-savings]');
    if (savings) {
      if (savingsCents > 0) {
        var formattedSavings =
          window.Shopify && Shopify.formatMoney && window.theme && theme.settings
            ? Shopify.formatMoney(savingsCents, theme.settings.moneyFormat)
            : '$' + (savingsCents / 100).toFixed(2);
        // Whole-dollar savings read "$13", as in the drawer's applied-offer line.
        savings.textContent = 'You save ' + formattedSavings.replace(/\.00(?!\d)/, '');
        savings.hidden = false;
      } else {
        savings.textContent = '';
        savings.hidden = true;
      }
    }
  }

  function initCartDrawerScrollReset() {
    document.addEventListener('drawerOpen.CartDrawer', function () {
      var resetScroll = function () {
        var drawer = document.getElementById('CartDrawer');
        if (!drawer) return;

        var inner = drawer.querySelector('.drawer__inner');
        if (inner) {
          inner.scrollTop = 0;
        }

        var scrollable = drawer.querySelector('.drawer__inner > .drawer__scrollable');
        if (scrollable) {
          scrollable.scrollTop = 0;
        }
      };

      window.requestAnimationFrame(resetScroll);
      window.setTimeout(resetScroll, 120);
      window.setTimeout(resetScroll, 360);
    });
  }

  function getWalletSignals(element) {
    if (!element) return '';

    var parts = [];
    var seen = {};

    function push(value) {
      var token = normalizeText(value);
      if (!token || seen[token]) return;
      seen[token] = true;
      parts.push(token);
    }

    function collectFromNode(node) {
      if (!node || node.nodeType !== 1 || !node.getAttribute) return;
      ['aria-label', 'title', 'name', 'data-testid', 'data-provider', 'data-payment-method', 'alt', 'id', 'class'].forEach(
        function (attr) {
          push(node.getAttribute(attr));
        }
      );
      if (node.tagName && node.tagName.toLowerCase() === 'iframe') {
        push(node.getAttribute('src'));
      }
    }

    collectFromNode(element);

    var descendants = element.querySelectorAll
      ? element.querySelectorAll('[aria-label],[title],[name],[data-testid],[data-provider],[data-payment-method],[alt],[id],[class],iframe')
      : [];
    var maxDescendants = Math.min(descendants.length, 120);
    for (var i = 0; i < maxDescendants; i += 1) {
      collectFromNode(descendants[i]);
    }

    push(element.textContent || '');
    push(element.innerHTML || '');

    return parts.join(' ');
  }

  function detectWalletProvider(element) {
    var haystack = getWalletSignals(element);
    if (!haystack) return 'unknown';

    if (
      haystack.indexOf('shop pay') !== -1 ||
      haystack.indexOf('shop-pay') !== -1 ||
      haystack.indexOf('shop_pay') !== -1 ||
      haystack.indexOf('shoppay') !== -1 ||
      haystack.indexOf('shopify pay') !== -1
    ) {
      return 'shop';
    }

    if (
      haystack.indexOf('paypal') !== -1 ||
      haystack.indexOf('pay pal') !== -1 ||
      haystack.indexOf('paypal.com') !== -1 ||
      haystack.indexOf('paypalobjects') !== -1
    ) {
      return 'paypal';
    }

    if (
      haystack.indexOf('amazon') !== -1 ||
      haystack.indexOf('amzn') !== -1 ||
      haystack.indexOf('amazon pay') !== -1
    ) {
      return 'amazon';
    }

    if (
      haystack.indexOf('google pay') !== -1 ||
      haystack.indexOf('googlepay') !== -1 ||
      haystack.indexOf('gpay') !== -1 ||
      haystack.indexOf('pay.google') !== -1
    ) {
      return 'google';
    }

    if (haystack.indexOf('apple pay') !== -1 || haystack.indexOf('applepay') !== -1) {
      return 'apple';
    }

    return 'other';
  }

  function getCartDrawerWalletContainers(drawer) {
    if (!drawer) return [];

    var nested = Array.prototype.slice.call(
      drawer.querySelectorAll('.additional-checkout-buttons [data-shopify-buttoncontainer]')
    );
    if (nested.length) {
      return nested;
    }

    return Array.prototype.slice
      .call(drawer.querySelectorAll('.additional-checkout-buttons'))
      .filter(function (container) {
        return !!container;
      });
  }

  function getWalletCandidates(container) {
    if (!container || !container.children) return [];
    return Array.prototype.filter.call(container.children, function (child) {
      if (!child || child.nodeType !== 1) return false;
      var tag = (child.tagName || '').toLowerCase();
      return tag !== 'script' && tag !== 'style' && tag !== 'template';
    });
  }

  function setWalletVisible(node, visible) {
    if (!node) return;
    node.classList.toggle('tall-owl-wallet-hidden', !visible);
    if (visible) {
      node.removeAttribute('aria-hidden');
      node.style.removeProperty('display');
      return;
    }
    node.setAttribute('aria-hidden', 'true');
    node.style.setProperty('display', 'none', 'important');
  }

  function filterCartDrawerWalletButtons() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;

    var containers = getCartDrawerWalletContainers(drawer);
    if (!containers.length) return;

    containers.forEach(function (container) {
      container.classList.add('tall-owl-wallet-container');

      var candidates = getWalletCandidates(container);
      if (!candidates.length) return;

      var shopNode = null;
      var paypalNode = null;
      var allowedFallback = [];

      candidates.forEach(function (candidate) {
        var provider = detectWalletProvider(candidate);
        candidate.setAttribute('data-tall-owl-wallet-provider', provider);

        if (provider === 'shop' && !shopNode) {
          shopNode = candidate;
        } else if (provider === 'paypal' && !paypalNode) {
          paypalNode = candidate;
        } else if (provider !== 'amazon' && provider !== 'google' && provider !== 'apple') {
          allowedFallback.push(candidate);
        }
      });

      var keep = [];
      if (shopNode) keep.push(shopNode);
      if (paypalNode && keep.indexOf(paypalNode) === -1) keep.push(paypalNode);

      if (keep.length < 2) {
        allowedFallback.forEach(function (candidate) {
          if (keep.length >= 2) return;
          if (keep.indexOf(candidate) !== -1) return;
          keep.push(candidate);
        });
      }

      if (keep.length < 2) {
        candidates.forEach(function (candidate) {
          if (keep.length >= 2) return;
          if (keep.indexOf(candidate) !== -1) return;
          keep.push(candidate);
        });
      }

      keep = keep.slice(0, 2);

      candidates.forEach(function (candidate) {
        var visible = keep.indexOf(candidate) !== -1;
        setWalletVisible(candidate, visible);
        candidate.style.order = visible ? String(keep.indexOf(candidate) + 1) : '';
      });
    });
  }

  function scheduleCartDrawerWalletFilter() {
    [0, 120, 360, 900].forEach(function (delay) {
      window.setTimeout(filterCartDrawerWalletButtons, delay);
    });
  }

  function initCartDrawerWalletButtons() {
    scheduleCartDrawerWalletFilter();

    var drawer = document.getElementById('CartDrawer');
    if (!drawer || !window.MutationObserver) return;

    var observer = new MutationObserver(function () {
      scheduleCartDrawerWalletFilter();
    });

    observer.observe(drawer, {
      childList: true,
      subtree: true
    });

    document.addEventListener('cart:updated', function () {
      scheduleCartDrawerWalletFilter();
    });

    document.addEventListener('drawerOpen.CartDrawer', function () {
      scheduleCartDrawerWalletFilter();
    });

    window.addEventListener('load', function () {
      scheduleCartDrawerWalletFilter();
    });
  }

  function submitKlaviyoJsonp(listId, email, source, onSuccess, onError) {
    var callbackName = 'tallOwlKlaviyo_' + Date.now() + '_' + Math.floor(Math.random() * 10000);
    var script = document.createElement('script');
    var cleaned = false;

    function cleanup() {
      if (cleaned) return;
      cleaned = true;
      if (script.parentNode) script.parentNode.removeChild(script);
      try {
        delete window[callbackName];
      } catch (error) {
        window[callbackName] = undefined;
      }
    }

    window[callbackName] = function (response) {
      cleanup();
      if (response && (response.success || response.data)) {
        onSuccess();
      } else {
        onError();
      }
    };

    script.async = true;
    script.src =
      'https://manage.kmail-lists.com/ajax/subscriptions/subscribe?callback=' +
      encodeURIComponent(callbackName) +
      '&g=' +
      encodeURIComponent(listId) +
      '&email=' +
      encodeURIComponent(email) +
      '&$fields=' +
      encodeURIComponent('$source') +
      '&$source=' +
      encodeURIComponent(source || 'homepage-newsletter');

    script.onerror = function () {
      cleanup();
      onError();
    };

    window.setTimeout(function () {
      if (!cleaned) {
        cleanup();
        onError();
      }
    }, 10000);

    document.head.appendChild(script);
  }

  function initKlaviyoNewsletterForms() {
    var forms = document.querySelectorAll('form[data-klaviyo-form]');
    if (!forms.length) return;

    forms.forEach(function (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();

        var listId = form.getAttribute('data-klaviyo-list-id') || '';
        var source = form.getAttribute('data-newsletter-source') || 'homepage-newsletter';
        var emailInput = form.querySelector('input[type="email"]');
        var submitBtn = form.querySelector('button[type="submit"]');
        var status = form.querySelector('[data-newsletter-status]');
        var email = emailInput ? emailInput.value.trim() : '';
        var emailIsValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

        if (!emailIsValid || !listId) {
          if (status) {
            status.textContent = 'Please enter a valid email address and try again.';
            status.classList.remove('tall-owl-newsletter__status--success');
            status.classList.add('tall-owl-newsletter__status--error');
          }
          return;
        }

        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.setAttribute('aria-busy', 'true');
        }
        if (status) {
          status.textContent = 'Submitting...';
          status.classList.remove('tall-owl-newsletter__status--success', 'tall-owl-newsletter__status--error');
        }

        submitKlaviyoJsonp(
          listId,
          email,
          source,
          function () {
            if (status) {
              status.textContent = 'Success. Check your inbox for your welcome email.';
              status.classList.remove('tall-owl-newsletter__status--error');
              status.classList.add('tall-owl-newsletter__status--success');
            }
            form.reset();
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.removeAttribute('aria-busy');
            }
          },
          function () {
            if (status) {
              status.textContent = 'Unable to subscribe right now. Please try again.';
              status.classList.remove('tall-owl-newsletter__status--success');
              status.classList.add('tall-owl-newsletter__status--error');
            }
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.removeAttribute('aria-busy');
            }
          }
        );
      });
    });
  }

  function normalizeInputModes() {
    document.querySelectorAll('input[type="email"]:not([inputmode])').forEach(function (el) {
      el.setAttribute('inputmode', 'email');
    });
    document.querySelectorAll('input[type="tel"]:not([inputmode])').forEach(function (el) {
      el.setAttribute('inputmode', 'tel');
    });
    document.querySelectorAll('input[type="search"]:not([inputmode])').forEach(function (el) {
      el.setAttribute('inputmode', 'search');
    });
    document.querySelectorAll('input[type="url"]:not([inputmode])').forEach(function (el) {
      el.setAttribute('inputmode', 'url');
    });
  }

  function buildContactCreationDate(now) {
    try {
      return new Intl.DateTimeFormat('en-US', {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
        timeZoneName: 'short'
      }).format(now);
    } catch (error) {
      return now.toISOString();
    }
  }

  function applyContactCreationDateFields(form) {
    if (!form || !form.querySelectorAll) return;
    var now = new Date();
    var formatted = buildContactCreationDate(now);
    var iso = now.toISOString();

    Array.prototype.forEach.call(form.querySelectorAll('[data-contact-creation-date]'), function (input) {
      input.value = formatted;
    });

    Array.prototype.forEach.call(form.querySelectorAll('[data-contact-creation-date-iso]'), function (input) {
      input.value = iso;
    });
  }

  function initContactCreationDateFields() {
    Array.prototype.forEach.call(document.querySelectorAll('form'), function (form) {
      if (!form.querySelector('[data-contact-creation-date], [data-contact-creation-date-iso]')) return;
      applyContactCreationDateFields(form);
    });

    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target;
        if (!form || !form.querySelector) return;
        if (!form.querySelector('[data-contact-creation-date], [data-contact-creation-date-iso]')) return;
        applyContactCreationDateFields(form);
      },
      true
    );
  }

  function collapseEmptyHomepageSections() {
    if (!document.body.classList.contains('template-index')) return;

    var wrappers = document.querySelectorAll('.main-content .shopify-section');
    wrappers.forEach(function (wrapper) {
      var visibleChildren = Array.prototype.filter.call(wrapper.children, function (child) {
        var tag = child.tagName;
        return tag !== 'STYLE' && tag !== 'SCRIPT';
      });
      if (!visibleChildren.length) {
        wrapper.setAttribute('hidden', 'hidden');
      }
    });
  }

  function initRevealAnimations() {
    var sections = Array.prototype.slice.call(document.querySelectorAll('.tall-owl-section'));
    if (!sections.length) return;

    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    sections.forEach(function (section) {
      section.setAttribute('data-tall-owl-reveal', 'true');
      if (reducedMotion) {
        section.classList.add('is-revealed');
      }
    });

    if (reducedMotion || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.08 }
    );

    sections.forEach(function (section) {
      observer.observe(section);
    });
  }

  function applyModalAccessibility() {
    document.querySelectorAll('.modal').forEach(function (modal) {
      if (!modal.hasAttribute('role')) modal.setAttribute('role', 'dialog');
      if (!modal.hasAttribute('aria-modal')) modal.setAttribute('aria-modal', 'true');
    });
  }

  function initQuickSheetSwipeDismiss() {
    var active = null;

    document.addEventListener(
      'touchstart',
      function (event) {
        var content = event.target.closest('.tall-owl-quick-sheet .modal__centered-content');
        if (!content) return;
        if (content.scrollTop > 0) return;
        active = {
          content: content,
          startY: event.touches[0].clientY,
          deltaY: 0
        };
      },
      { passive: true }
    );

    document.addEventListener(
      'touchmove',
      function (event) {
        if (!active) return;
        var y = event.touches[0].clientY;
        active.deltaY = Math.max(0, y - active.startY);
        if (active.deltaY > 0) {
          active.content.style.transform = 'translateY(' + Math.min(active.deltaY, 140) + 'px)';
        }
      },
      { passive: true }
    );

    document.addEventListener(
      'touchend',
      function () {
        if (!active) return;
        var content = active.content;
        var deltaY = active.deltaY;
        content.style.transform = '';
        if (deltaY > 80) {
          var modal = content.closest('.tall-owl-quick-sheet');
          var closeBtn = modal && modal.querySelector('.js-modal-close');
          if (closeBtn) closeBtn.click();
        }
        active = null;
      },
      { passive: true }
    );
  }

  document.addEventListener('ajaxProduct:added', function (event) {
    var product = event.detail && event.detail.product ? event.detail.product : null;
    var title = product && product.title ? product.title : 'Item';
    showToast(title + ' added to cart.');
  });

  document.addEventListener('shopify:section:load', function (event) {
    initVariantDescriptionBlocks(event && event.target ? event.target : document);
    initTallOwlPdpPairModules(event && event.target ? event.target : document);
  });

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('.tall-owl-mobile-atc, .tall-owl-card-atc');
    if (btn) {
      event.preventDefault();
      if (btn.disabled) return;

      var previousText = (btn.textContent || '').trim() || 'Add to Cart';
      btn.disabled = true;
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');
      btn.textContent = 'Adding...';

      addToCart(btn.getAttribute('data-variant-id'))
        .catch(function () {
          /* addToCart already handles user-facing error messaging */
        })
        .then(function () {
          btn.disabled = false;
          btn.classList.remove('is-loading');
          btn.removeAttribute('aria-busy');
          btn.textContent = previousText;
        });
      return;
    }

  });

  // Tall Owl free Lip Balm gift - auto add/remove + scent picker.
  // Mirrors the server-side tall-owl-promos threshold: when the merchandise
  // subtotal EXCLUDING the gift reaches the threshold, the gift variant is added
  // at its required $0 Admin price; below the threshold it is removed. Checkout
  // validation is the final eligibility/price backstop. Scent is changed via the
  // <select> rendered on the gift line in cart-item.liquid.
  function initTallOwlGiftPicker() {
    var config = document.querySelector('[data-tall-owl-gift-config]');
    if (!config || config.getAttribute('data-enabled') !== 'true') return;
    if (document.documentElement.hasAttribute('data-tall-owl-gift-bound')) return;
    document.documentElement.setAttribute('data-tall-owl-gift-bound', 'true');

    var GIFT_HANDLE = String(config.getAttribute('data-gift-handle') || '').toLowerCase();
    var DEFAULT_VARIANT = Number(config.getAttribute('data-default-variant') || 0);
    var THRESHOLD_CENTS = Number(config.getAttribute('data-threshold') || 5000);
    if (!GIFT_HANDLE || !DEFAULT_VARIANT) return;

    var busy = false;
    var syncPending = false;
    var syncTimer = null;
    var pendingScentVariant = 0;
    var refreshPending = false;
    var GIFT_SYNC_RETRY_DELAYS = [250, 750, 1500];

    function isGiftItem(item) {
      return !!item && String(item.handle || '').toLowerCase() === GIFT_HANDLE;
    }

    // An empty-gift baseline would make paid markup obsolete if a gift is added.
    // This optional-render decision never predicts or changes eligibility.
    window.tallOwlShouldBundlePaidCart = function (cart) {
      return !cart || !Array.isArray(cart.items) || cart.items.some(isGiftItem);
    };

    function subtotalExGiftCents(cart) {
      var items = cart && Array.isArray(cart.items) ? cart.items : [];
      /* Gift cards are money, not merchandise - a $50 gift card alone must
         not earn the free Lip Balm. Exclude them from the threshold the
         same way the gift line itself is excluded. */
      var excludedLineTotal = items.reduce(function (sum, item) {
        if (!isGiftItem(item) && !item.gift_card) return sum;
        return sum + Number(item.final_line_price || 0);
      }, 0);
      var postDiscountCartTotal = Number(cart && cart.total_price);

      // cart.total_price includes order-level discounts that Shopify may leave
      // unallocated on cart lines. Subtract gift-card lines and any invalid
      // nonzero gift line so only post-discount paid merchandise can qualify
      // for the threshold.
      if (Number.isFinite(postDiscountCartTotal) && postDiscountCartTotal >= 0) {
        return Math.max(0, postDiscountCartTotal - excludedLineTotal);
      }

      return items.reduce(function (sum, item) {
        if (isGiftItem(item) || item.gift_card) return sum;
        return sum + Number(item.final_line_price || 0);
      }, 0);
    }

    // The page-load check offers its read to the analytics script. Every
    // later sync, and any retry, reads alone.
    var offerLoadRead = false;
    function fetchCartJson() {
      var read = tallOwlCartRequest('/cart.js', { method: 'GET', credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (response) {
          if (!response.ok) {
            var error = new Error('Cart request failed with status ' + response.status);
            error.status = response.status;
            throw error;
          }
          return response.json();
        });
      if (offerLoadRead) {
        offerLoadRead = false;
        tallOwlOfferLoadCart(read);
      }
      return read;
    }

    function waitForGiftRetry(delay) {
      return new Promise(function (resolve) {
        window.setTimeout(resolve, delay);
      });
    }

    // Publish only a verified gift state. Gift-owned events are marked so they
    // refresh the drawer without recursively scheduling another reconciliation.
    function publishCartChanged(cart) {
      refreshPending = false;
      document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: { cart: cart, source: 'tall-owl-gift' }
      }));
      document.dispatchEvent(new CustomEvent('cart:build', {
        detail: { source: 'tall-owl-gift' }
      }));
      return cart;
    }

    // Every gift write answers with Shopify's complete discounted cart (the
    // same JSON a fresh /cart.js read returns), so verify and publish that
    // response instead of spending another round trip on a read.
    function settleGiftWrite(cart, quiet) {
      verifyGiftState(cart);
      return quiet ? cart : publishCartChanged(cart);
    }

    function writtenCart(cart, label) {
      if (!cart || !Array.isArray(cart.items)) {
        var error = new Error(label + ' did not return a cart');
        error.status = Number(cart && cart.status || 0);
        error.retriable = true;
        throw error;
      }
      return cart;
    }

    // Quiet write - deliberately does NOT dispatch ajaxProduct:added, so adding
    // the gift never triggers the BOGO popup (the gift isn't a BOGO item).
    // update.js SETS the gift variant to one unit: a repeated request can never
    // create a second gift, and the response is the full cart.
    function apiSetGift(variantId) {
      refreshPending = true;
      var updates = {};
      updates[String(Number(variantId))] = 1;
      return tallOwlCartRequest('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(tallOwlCartSectionRequest({ updates: updates }))
      }).then(function (response) {
        if (!response.ok) {
          var error = new Error('Gift add failed with status ' + response.status);
          error.status = response.status;
          throw error;
        }
        return response.json();
      }).then(function (cart) {
        return writtenCart(cart, 'Gift add');
      });
    }

    function apiChangeGift(key, quantity) {
      refreshPending = true;
      return theme.cart.changeItem(key, quantity).then(function (text) {
        return writtenCart(JSON.parse(text), 'Gift change');
      });
    }

    // ---- Cart mechanics: auto add/remove + scent swap ----
    function enableGiftScentSelectors() {
      var selects = document.querySelectorAll('[data-tall-owl-gift-scent]');
      for (var index = 0; index < selects.length; index += 1) {
        selects[index].disabled = false;
      }
    }

    function finishGiftOperation() {
      busy = false;
      enableGiftScentSelectors();
      if (tallOwlCartRecoveryRequired) { pendingScentVariant = 0; syncPending = false; return; }

      if (pendingScentVariant) {
        var variantId = pendingScentVariant;
        pendingScentVariant = 0;
        setGiftScent(variantId);
        return;
      }

      if (syncPending) {
        scheduleSync(0);
      }
    }

    function apiSwapGift(cart, variantId) {
      var giftLines = (cart.items || []).filter(isGiftItem);
      if (giftLines.some(function (line) {
        return Object.keys(line.properties || {}).length || line.selling_plan_allocation;
      })) throw new Error('Gift identity cannot be safely changed');
      var updates = {};
      var target = giftLines.filter(function (line) { return Number(line.variant_id) === Number(variantId); })[0];
      giftLines.forEach(function (line) { updates[line.key] = target && line.key === target.key ? 1 : 0; });
      if (!target) updates[String(Number(variantId))] = 1;
      refreshPending = true;
      return tallOwlCartRequest('/cart/update.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(function (response) {
        if (!response.ok) { var error = new Error('Gift scent change was rejected'); error.cartRejected = true; throw error; }
        return response.json();
      }).then(function (updatedCart) {
        verifyGiftState(updatedCart);
        var gifts = (updatedCart.items || []).filter(isGiftItem);
        if (gifts.length !== 1 || Number(gifts[0].variant_id) !== Number(variantId)) throw new Error('Gift scent change could not be verified');
        return publishCartChanged(updatedCart);
      }).catch(function (error) {
        return fetchCartJson().then(function (current) {
          if (tallOwlCartRecoveryRequired) { publishCartChanged(current); throw error; }
          var previous = giftLines[0];
          var currentGifts = (current.items || []).filter(isGiftItem);
          if (previous && currentGifts.length === 1 && Number(currentGifts[0].variant_id) === Number(previous.variant_id) && Number(currentGifts[0].quantity) === Number(previous.quantity)) {
            publishCartChanged(current);
            throw error;
          }
          // A known partial update is restored in one quantity-setting request;
          // no add/remove sequence exposes two gift units or loses the old one.
          var rollbackUpdates = {};
          currentGifts.forEach(function (line) { rollbackUpdates[line.key] = 0; });
          giftLines.forEach(function (line) {
            var existing = currentGifts.filter(function (item) { return Number(item.variant_id) === Number(line.variant_id); })[0];
            rollbackUpdates[existing ? existing.key : String(Number(line.variant_id))] = Number(line.quantity);
          });
          return tallOwlCartRequest('/cart/update.js', {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates: rollbackUpdates })
          }).then(function (response) { if (!response.ok) throw new Error('Gift scent recovery was rejected'); return response.json(); })
            .then(function (restored) {
              verifyGiftState(restored);
              var restoredGifts = (restored.items || []).filter(isGiftItem);
              if (restoredGifts.length !== giftLines.length || !giftLines.every(function (line) {
                return restoredGifts.some(function (restoredLine) { return Number(restoredLine.variant_id) === Number(line.variant_id) && Number(restoredLine.quantity) === Number(line.quantity); });
              })) throw new Error('Gift scent recovery could not be verified');
              publishCartChanged(restored);
              throw error;
            });
        }).catch(function (recoveryError) {
          if (recoveryError !== error) tallOwlRequireCartRecovery(recoveryError);
          throw recoveryError;
        });
      });
    }

    function setGiftScent(variantId) {
      if (!variantId) return Promise.resolve(null);
      if (busy) {
        pendingScentVariant = variantId;
        syncPending = true;
        return Promise.resolve(null);
      }

      busy = true;
      return tallOwlQueueCartWrite(function () {
        return fetchCartJson()
        .then(function (cart) {
          var line = cart && Array.isArray(cart.items) ? cart.items.filter(isGiftItem)[0] : null;
          if (!cart) throw new Error('Unable to read cart');
          if (line && Number(line.variant_id) === Number(variantId)) return cart;
          if (!line || subtotalExGiftCents(cart) < THRESHOLD_CENTS) return reconcileGiftOnce(cart);
          return apiSwapGift(cart, variantId);
        });
      })
        .then(
          function (cart) {
            clearTallOwlCartFeedback();
            finishGiftOperation();
            return cart;
          },
          function (error) {
            syncPending = !tallOwlCartRecoveryRequired;
            showToast(error && error.recoveryRequired
              ? 'Reload this page to check your cart before making another change.'
              : 'We could not confirm your gift scent change. Review your cart before choosing the scent again.', true);
            finishGiftOperation();
            return null;
          }
        );
    }

    function totalGiftQuantity(cart) {
      var items = cart && Array.isArray(cart.items) ? cart.items : [];
      return items.reduce(function (quantity, item) {
        return quantity + (isGiftItem(item) ? Number(item.quantity || 0) : 0);
      }, 0);
    }

    function verifyGiftState(cart) {
      if (!cart) throw new Error('Unable to verify cart');
      var qualifies = subtotalExGiftCents(cart) >= THRESHOLD_CENTS;
      var giftQuantity = totalGiftQuantity(cart);
      if ((qualifies && giftQuantity !== 1) || (!qualifies && giftQuantity !== 0)) {
        var error = new Error('Gift state did not match cart eligibility');
        error.retriable = true;
        throw error;
      }
      return cart;
    }

    // Called only while the shared write lock is held. A fresh paid cart may
    // seed the first pass; retries always read again before another gift write.
    function reconcileGiftOnce(confirmedCart, quiet) {
      return (confirmedCart ? Promise.resolve(confirmedCart) : fetchCartJson())
        .then(function (cart) {
          if (!cart) throw new Error('Unable to read cart');
          var items = Array.isArray(cart.items) ? cart.items : [];
          var giftLines = items.filter(isGiftItem);
          var qualifies = subtotalExGiftCents(cart) >= THRESHOLD_CENTS;
          var giftLine = giftLines[0] || null;

          if (!qualifies && giftLines.length) {
            var chain = Promise.resolve();
            giftLines.forEach(function (line) {
              chain = chain.then(function () { return apiChangeGift(line.key, 0); });
            });
            return chain.then(function (updatedCart) { return settleGiftWrite(updatedCart, quiet); });
          }

          if (qualifies && !giftLine) {
            return apiSetGift(DEFAULT_VARIANT)
              .then(function (updatedCart) { return settleGiftWrite(updatedCart, quiet); })
              .then(function (updatedCart) {
                // No modal on unlock: the cart drawer (which opens on add) shows
                // the gift line with its scent dropdown. A toast covers the cases
                // where the unlock happens without the drawer visible.
                if (typeof showToast === 'function') {
                  showToast('Free Lip Balm added - pick your scent in the cart.');
                }
                return updatedCart;
              });
          }

          // Collapse duplicate gift lines and quantities to exactly one unit.
          if (qualifies && (giftLines.length > 1 || Number(giftLine.quantity || 0) !== 1)) {
            var normalizeChain = Promise.resolve();
            if (Number(giftLine.quantity || 0) !== 1) {
              normalizeChain = normalizeChain.then(function () {
                return apiChangeGift(giftLine.key, 1);
              });
            }
            giftLines.slice(1).forEach(function (line) {
              normalizeChain = normalizeChain.then(function () {
                return apiChangeGift(line.key, 0);
              });
            });
            return normalizeChain.then(function (updatedCart) { return settleGiftWrite(updatedCart, quiet); });
          }

          var verifiedCart = verifyGiftState(cart);
          return refreshPending && !quiet ? publishCartChanged(verifiedCart) : verifiedCart;
        });
    }

    function reconcileGift(attempt, confirmedCart, quiet) {
      return reconcileGiftOnce(confirmedCart, quiet).catch(function (error) {
        if (tallOwlCartRecoveryRequired || error && error.recoveryRequired) throw error;
        var status = Number(error && error.status || 0);
        var retriable = !!(error && error.retriable) || !status || status === 429 || status >= 500;
        if (!retriable || attempt >= GIFT_SYNC_RETRY_DELAYS.length) throw error;
        return waitForGiftRetry(GIFT_SYNC_RETRY_DELAYS[attempt])
          .then(function () { return reconcileGift(attempt + 1, null, quiet); });
      });
    }

    function syncGift() {
      if (busy) {
        syncPending = true;
        return Promise.resolve(null);
      }

      busy = true;
      return tallOwlQueueCartWrite(function () { return reconcileGift(0); }).then(
        function (cart) {
          finishGiftOperation();
          return cart;
        },
        function (error) {
          if (window.console && typeof window.console.warn === 'function') {
            window.console.warn('[Tall Owl] Free gift cart sync failed.', error);
          }
          finishGiftOperation();
          return null;
        }
      );
    }

    // The paid add owns the lock: never enqueue or wait for busy background
    // work here. Its cart was read after Shopify confirmed the paid items.
    window.tallOwlReconcileGiftAfterAdd = function (confirmedCart, paidSections, requireFullCart) {
      if (syncTimer) window.clearTimeout(syncTimer);
      syncTimer = null;
      syncPending = false;
      var paidCart = confirmedCart;
      var readPaidCart = paidCart ? Promise.resolve(paidCart) : fetchCartJson();
      return readPaidCart.then(function (cart) {
        // Supplied markup belongs to this paid request, never a previous add.
        if (paidSections !== undefined) cart.sections = paidSections;
        paidCart = cart;
        return reconcileGiftOnce(cart, true);
      }).then(function (cart) {
        function finish(nativeCart) {
          refreshPending = false;
          holdPaidAddEvents();
          return nativeCart;
        }
        if (requireFullCart && tallOwlIsCartStateProjection(cart)) {
          return fetchCartJson().then(function (nativeCart) {
            writtenCart(nativeCart, 'Complete cart read');
            verifyGiftState(nativeCart);
            nativeCart.sections = cart.sections;
            return finish(nativeCart);
          }).catch(function (error) { throw tallOwlRequireCartRecovery(error); });
        }
        return finish(cart);
      }, function (error) {
        // A failed gift write can have applied. Never reuse earlier paid markup
        // even if the recovery read fails and verified paid data is retained.
        if (paidCart) delete paidCart.sections;
        if (window.console && typeof window.console.warn === 'function') {
          window.console.warn('[Tall Owl] Immediate free gift sync was not confirmed.', error);
        }
        // A failed response can follow an applied write. Read once to recover
        // the actual cart; never repeat the paid add or blindly add the gift.
        scheduleSync();
        return fetchCartJson().then(function (cart) {
          return requireFullCart ? writtenCart(cart, 'Cart recovery') : cart;
        }).catch(function (error) {
          if (requireFullCart) throw tallOwlRequireCartRecovery(error);
          return paidCart || null;
        });
      });
    };

    function scheduleSync(delay) {
      if (tallOwlCartRecoveryRequired) { syncPending = false; return; }
      syncPending = true;
      if (busy) return;
      if (syncTimer) window.clearTimeout(syncTimer);
      syncTimer = window.setTimeout(function () {
        syncTimer = null;
        syncPending = false;
        syncGift();
      }, typeof delay === 'number' ? delay : 180);
    }

    // Cart-line dropdown change ? swap scent.
    document.addEventListener('change', function (event) {
      var select = event.target.closest('[data-tall-owl-gift-scent]');
      if (!select) return;
      var newId = Number(select.value);
      if (!newId) return;
      select.disabled = true;
      setGiftScent(newId);
    });

    // The paid add publishes the cart verified above in the same task
    // (cart:updated, ajaxProduct:added, cart:build and the drawer opening).
    // Those events must not schedule a second verification read; later events
    // (another tab's change, reopening the drawer) still do.
    var paidAddPublishing = false;
    function holdPaidAddEvents() {
      paidAddPublishing = true;
      window.setTimeout(function () {
        paidAddPublishing = false;
      }, 0);
    }

    function handleGiftCartEvent(event) {
      if (paidAddPublishing) return;
      if (event && event.detail && event.detail.source === 'tall-owl-gift') return;
      scheduleSync();
    }

    document.addEventListener('cart:updated', handleGiftCartEvent);
    document.addEventListener('cart:build', handleGiftCartEvent);
    document.addEventListener('ajaxProduct:added', handleGiftCartEvent);
    document.addEventListener('drawerOpen.CartDrawer', handleGiftCartEvent);

    offerLoadRead = true;
    syncGift();
  }

  // Sticky add bar: the buy button follows the shopper. Visible whenever the
  // real quantity-picker CTA has been passed. Clicks proxy to the real CTA so
  // quantity selection, lazy loading, and the atomic pair path all apply.
  function initTallOwlStickyAdd() {
    var bar = document.querySelector('[data-tall-owl-sticky-add]');
    /* Pair-eligible products mirror the picker CTA; every other product
       (Lip Balm, gift card, preorder) mirrors its native add-to-cart, so
       no PDP scrolls without a visible buy action. */
    var cta = document.querySelector('[data-tall-owl-pair-cta]') ||
      document.querySelector('.product-single__meta form[action*="/cart/add"] [data-add-to-cart]');
    var nativeCta = cta;
    var lipModule = document.querySelector('[data-lip-bundle]:not([hidden])');
    var isLipBundle = false;
    if (!bar || !cta || !('IntersectionObserver' in window)) return;
    var barButton = bar.querySelector('[data-tall-owl-sticky-add-button]');
    if (!barButton) return;
    var isPairCta = cta.hasAttribute('data-tall-owl-pair-cta');
    var barTitle = bar.querySelector('.tall-owl-sticky-add__title');
    /* An unavailable selection never leaves a dead "Sold out" pill: the bar
       offers the in-page note's nearest available option and clicks that same
       button, so its handler and focus handoff to the changed option apply. */
    var pairModuleNode = isPairCta ? cta.closest('[data-tall-owl-pair-module]') : null;
    var soldoutNote = pairModuleNode && pairModuleNode.querySelector('[data-tall-owl-pair-soldout]');
    var barLabel = barButton.getAttribute('aria-label');
    function soldoutChoice() {
      if (!soldoutNote || soldoutNote.hidden || !cta.disabled) return null;
      var choose = soldoutNote.querySelector('[data-tall-owl-pair-soldout-choose]');
      return choose && !choose.hidden && choose.textContent.trim() ? choose : null;
    }

    function mirror() {
      if (lipModule) {
        isLipBundle = lipModule.getAttribute('data-mode') === 'bundle';
        cta = isLipBundle ? lipModule.querySelector('[data-lip-build]') : nativeCta;
      }
      var choose = soldoutChoice();
      barButton.textContent = (choose || cta).textContent.trim() || 'Add';
      barButton.disabled = choose ? false : cta.disabled;
      // The cold loader also marks busy before it disables the real CTA.
      barButton.setAttribute('aria-busy', !choose && cta.getAttribute && cta.getAttribute('aria-busy') === 'true' ? 'true' : 'false');
      if (choose) barButton.setAttribute('aria-label', choose.textContent.trim());
      else if (isLipBundle) barButton.setAttribute('aria-label', cta.textContent.trim());
      else if (barLabel) barButton.setAttribute('aria-label', barLabel);
      // Show the actual native scent/size selections next to the mirrored
      // quantity and total. Reading this context never changes the selection.
      if (barTitle) {
        var selections = Array.prototype.map.call(
          document.querySelectorAll('.product-single__meta .variant-input-wrap'),
          function (group) {
            var choice = group.querySelector('input:checked');
            return choice ? choice.value : '';
          }
        ).filter(Boolean);
        /* When the bar sells two, name the live pair saving so the mirrored
           total explains itself ("Vanilla Orange · 3.0 oz · Save $19"). */
        var pairModule = isPairCta && /^Add 2\b/i.test(barButton.textContent)
          ? cta.closest('[data-tall-owl-pair-module]') : null;
        var saveNode = pairModule && pairModule.querySelector('[data-tall-owl-pair-save]');
        var saveText = saveNode ? saveNode.textContent.trim() : '';
        if (saveText) selections.push(saveText);
        // An unavailable selection names itself exactly as the in-page note;
        // otherwise keep "3.0 oz" and each separator with its value on phones.
        var soldText = choose && soldoutNote.querySelector('[data-tall-owl-pair-soldout-text]');
        if (isLipBundle) barTitle.textContent = '4 Lip Balms · one size, mix scents';
        else if (soldText && soldText.textContent.trim()) barTitle.textContent = soldText.textContent.trim();
        else if (selections.length) barTitle.textContent = selections.join('\u00a0· ').replace(/(\d) (?=[a-z])/gi, '$1\u00a0');
      }
    }
    mirror();
    new MutationObserver(mirror).observe(cta, {
      childList: true,
      characterData: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled', 'aria-busy']
    });
    if (lipModule) {
      new MutationObserver(mirror).observe(lipModule, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['data-mode', 'disabled', 'aria-busy'] });
      document.addEventListener('tallowl:lip-mode', function () { mirror(); syncVisibility(); });
    }
    if (soldoutNote) {
      new MutationObserver(mirror).observe(soldoutNote, {
        childList: true,
        characterData: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['hidden']
      });
    }

    /* Watch the whole pair module on desktop and protected landings: the
       bottom-right pill otherwise covers the price stack it mirrors. On
       ordinary phone PDPs, let the bottom bar take over as soon as the
       main Add action scrolls above the viewport. The offer/reassurance
       continues below that action, so waiting for the whole module leaves
       an unnecessary gap without a visible Add button. */
    var observeTarget = (isPairCta && cta.closest('[data-tall-owl-pair-module]')) || cta;
    var visibilityQueued = false;
    function syncVisibility() {
      if (visibilityQueued) return;
      visibilityQueued = true;
      window.requestAnimationFrame(function () {
        visibilityQueued = false;
        var ordinaryPhone = isPairCta && bar.closest('.tall-owl-pdp-layout') &&
          window.matchMedia('(max-width: 768px)').matches;
        var visibilityTarget = lipModule ? cta : ordinaryPhone ? cta : observeTarget;
        var bounds = visibilityTarget.getBoundingClientRect();
        /* A laptop screen opens with the Add button below the first screen
           while the top of its module already shows, so the module rule
           alone left no way to buy in view. Until the shopper reaches the
           button the bar leads in its full-width form, which covers none of
           the price stack. As on the focused landings it steps aside once
           the quantity cards are mostly (60%) on screen. */
        var leading = false;
        if (visibilityTarget === observeTarget && observeTarget !== cta &&
            cta.getBoundingClientRect().top >= window.innerHeight) {
          var choice = observeTarget.querySelector('.tall-owl-pair-qty');
          var choiceBounds = choice ? choice.getBoundingClientRect() : null;
          var choiceShown = choiceBounds
            ? Math.min(choiceBounds.bottom, window.innerHeight) - Math.max(choiceBounds.top, 0) : 0;
          leading = !choiceBounds || choiceBounds.height <= 0 || choiceShown < choiceBounds.height * 0.6;
        }
        bar.classList.toggle('is-leading', leading);
        bar.hidden = !leading && bounds.bottom > 0 && bounds.top < window.innerHeight;
      });
    }
    // Intersection alone misses a jump from below to above the viewport.
    // Batch scroll reads once per frame, including restored/anchor positions.
    new IntersectionObserver(syncVisibility, { threshold: 0 }).observe(observeTarget);
    window.addEventListener('scroll', syncVisibility, { passive: true });
    window.addEventListener('resize', syncVisibility);
    syncVisibility();

    barButton.addEventListener('click', function () {
      var target = soldoutChoice() || cta;
      // The cart drawer this add opens hands focus back to the bar, not to
      // the off-screen buy box (theme.js CartDrawer.open).
      if (target === cta && !cta.disabled) cta.tallOwlReturnFocus = barButton;
      target.click();
    });

    /* The add flow reports progress and failure only into the buy box's
       status node - several screens away from a shopper who tapped the
       sticky bar. Mirror that status onto the bar so a failed add is
       never silent. */
    var status = document.querySelector('[data-tall-owl-pair-status]') || (lipModule && lipModule.querySelector('[data-lip-status]'));
    if (status) {
      var barStatus = document.createElement('p');
      barStatus.className = 'tall-owl-sticky-add__status';
      barStatus.setAttribute('role', 'status');
      barStatus.setAttribute('aria-live', 'polite');
      barStatus.hidden = true;
      bar.insertBefore(barStatus, bar.firstChild);
      new MutationObserver(function () {
        var text = status.textContent.trim();
        var show = !bar.hidden && text.length > 0;
        barStatus.textContent = show ? text : '';
        barStatus.hidden = !show;
        barStatus.classList.toggle('is-error', show && status.classList.contains('is-error'));
      }).observe(status, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    }
  }

  normalizeInputModes();
  initContactCreationDateFields();
  collapseEmptyHomepageSections();
  initRevealAnimations();
  initKlaviyoNewsletterForms();
  initCollectionGridRatings(document);
  initRotatingScentCards(document);
  initCollectionCardForms(document);
  initCollectionGridRatingsObserver();
  initVariantDescriptionBlocks(document);
  initVariantDescriptionObserver();
  initQuickSheetSwipeDismiss();
  initCartDrawerScrollReset();
  initCartRemoveLinkGuard();
  initTallOwlCartVariantSwap();
  initTallOwlCartCrossSellAdd();
  initTallOwlPdpPairModules(document);
  normalizeTallOwlFullCart();
  initTallOwlGiftPicker();
  initTallOwlStickyAdd();
  document.addEventListener('cart:markup:updated', normalizeTallOwlFullCart);
  // ---------- Gallery filtering ----------
  // Theme image sets own gallery filtering. Whipped Tallow uses exact
  // scent-and-size groups; products without complete exact media stay on
  // their native scent grouping.


  applyModalAccessibility();
})();
/* ==========================================================================
   Tall Owl scroll reveal - gentle fade + rise as sections enter the viewport.
   - No-op if IntersectionObserver is unsupported or reduced motion is preferred.
   - Content above the fold is never hidden (no load flash).
   - Footer/header are untouched; only .tall-owl-section content reveals.
   ========================================================================== */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var docEl = document.documentElement;
  var STAGGER = 90; // ms between staggered items
  var MAX_STEPS = 6; // cap so long lists never feel slow
  var GRID_SELECTOR = '.tall-owl-grid, .tall-owl-bestsellers';
  var observer;

  function getObserver() {
    if (observer) return observer;
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    return observer;
  }

  /* rev 2026-06-10b: hero excluded from reveal (LCP fix) */
  function collectSection(section, out) {
    // Never animate the hero: it holds the LCP image, and on slow loads the
    // above-fold check can misjudge it mid-layout, hiding the LCP for ~2s
    // (the source of the bimodal 15s mobile LCP in Lighthouse/PSI).
    if (section.classList && section.classList.contains('tall-owl-hero')) return;
    var container = section.querySelector('.tall-owl-container') || section;
    var items = Array.prototype.slice.call(container.children);
    // If one wrapper holds everything, step inside it so the children cascade.
    if (items.length === 1 && items[0].children && items[0].children.length > 1) {
      items = Array.prototype.slice.call(items[0].children);
    }
    items.forEach(function (item, i) {
      if (item.matches && item.matches(GRID_SELECTOR)) {
        Array.prototype.slice.call(item.children).forEach(function (card, ci) {
          if (card && card.nodeType === 1 && !card.classList.contains('to-reveal')) {
            out.push({ el: card, index: ci });
          }
        });
      } else if (item && item.nodeType === 1 && !item.classList.contains('to-reveal')) {
        out.push({ el: item, index: i });
      }
    });
  }

  function applyReveal(candidates) {
    if (!candidates.length) return;
    // Batch every geometry read before any class/style write - interleaving the
    // two forces a synchronous reflow per element (flagged by Lighthouse).
    var foldLine = window.innerHeight * 0.88;
    var tops = candidates.map(function (c) {
      return c.el.getBoundingClientRect().top;
    });
    candidates.forEach(function (c, i) {
      // Leave anything already at/above the fold visible - animate only what's below it.
      if (tops[i] < foldLine) return;
      c.el.style.setProperty('--to-delay', (Math.min(c.index, MAX_STEPS) * STAGGER) + 'ms');
      c.el.classList.add('to-reveal');
      getObserver().observe(c.el);
    });
  }

  function revealSection(section) {
    var candidates = [];
    collectSection(section, candidates);
    applyReveal(candidates);
  }

  function init(scope) {
    var root = scope || document.querySelector('.main-content') || document;
    var sections = root.querySelectorAll('.tall-owl-section');
    if (!sections.length) return;
    docEl.classList.add('to-reveal-ready');
    var candidates = [];
    Array.prototype.forEach.call(sections, function (section) {
      collectSection(section, candidates);
    });
    applyReveal(candidates);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Re-arm sections re-rendered inside the theme editor.
  document.addEventListener('shopify:section:load', function (event) {
    var target = event.target;
    if (!target || !target.querySelectorAll) return;
    docEl.classList.add('to-reveal-ready');
    if (target.classList && target.classList.contains('tall-owl-section')) {
      revealSection(target);
    }
    Array.prototype.forEach.call(target.querySelectorAll('.tall-owl-section'), revealSection);
  });
})();
